(function () {
  var FLAG = "ap_cart_drawer";
  var PRIORITY_PLUS_STATE_KEY = "ap_priority_plus_selected_v2";
  var BUNDLE_CACHE_KEY = "ap_cart_bundle_groups_v3";
  var CART_GROUP_CACHE_KEY = "ap_cart_merch_groups_v1";
  var ROOM_MIST_UPSELL_HANDLE = "ritz-carlton-hotel-inspired-room-mist-spray";
  var HUMIDIFYING_CLEANER_UPSELL_HANDLE = "humidifying-diffuser-cleaner-descaling-residue-removal-solution-for-ultrasonic-diffusers";
  var WATERLESS_CLEANER_UPSELL_HANDLE = "waterless-diffuser-cleaning-liquid-residue-free-formula-for-cold-air-nebulizing-diffusers";
  var CHECKOUT_RETURN_PATH_KEY = "ap_checkout_return_path";
  var DROPPER_UPSELL_HANDLE = "fragrance-dropper";
  var DROPPER_ELIGIBLE_CACHE_KEY = "ap_cart_dropper_eligible_v1";
  var root = document.querySelector("[data-ap-cart]");
  if (!root) return;
  var i18n = {};
  try {
    var i18nNode = root.querySelector("[data-ap-cart-i18n]");
    i18n = i18nNode ? JSON.parse(i18nNode.textContent) : {};
  } catch (e) {}
  var localeRoot = String(i18n.root || "/").replace(/\/$/, "");

  function text(key, fallback) {
    return i18n[key] || fallback || "";
  }

  function formatText(key, fallback, values) {
    var value = text(key, fallback);
    Object.keys(values || {}).forEach(function (token) {
      value = value.split("__" + token.toUpperCase() + "__").join(String(values[token]));
    });
    return value;
  }

  function localePath(path) {
    path = String(path || "");
    if (!path || path === "#" || /^(?:https?:)?\/\//i.test(path)) return path;
    if (localeRoot && (path === localeRoot || path.indexOf(localeRoot + "/") === 0)) return path;
    return localeRoot + "/" + path.replace(/^\//, "");
  }

  var state = {
    cart: null,
    cartFetch: null,
    refreshTimer: null,
    recsTimer: null,
    mutationTimer: null,
    recommendationsFor: null,
    recommendationsAbort: null,
    groupRecommendations: {},
    groupRecommendationAborts: {},
    bundleSuggestions: {},
    bundleSuggestionHtml: {},
    bundleSuggestionAborts: {},
    bundleGroupsLoaded: false,
    bundleGroupsLoading: null,
    bundleProductGroups: {},
    cartGroupsLoaded: false,
    cartGroupsLoading: null,
    cartProductGroups: {},
    errorTimer: null,
    loyaltyTimer: null,
    priorityPlusEnabled: readPriorityPlusPreference(),
    priorityPlusCleanupKey: null,
    protectionCleanupKey: null,
    recommendationsPrimedFor: null,
    roomMistUpsellProduct: null,
    roomMistUpsellLoading: null,
    roomMistUpsellUnavailable: false,
    humidifyingCleanerProduct: null,
    humidifyingCleanerLoading: null,
    humidifyingCleanerUnavailable: false,
    waterlessCleanerProduct: null,
    waterlessCleanerLoading: null,
    waterlessCleanerUnavailable: false,
    dropperProduct: null,
    dropperLoading: null,
    dropperUnavailable: false,
    dropperEligibleLoaded: false,
    dropperEligibleLoading: null,
    dropperEligibleProducts: {},
    sizeUpgradeProducts: {},
    sizeUpgradeLoading: {},
    sizeUpgradeExpanded: false,
    sizeUpgradeBusy: false,
    sizeUpgradeUndo: null,
    sizeUpgradeSuccess: null
  };

  var BUNDLE_GROUPS = [
    { key: "regular-hotel", label: text("hotel_oils", "Hotel fragrance oils"), handle: "hotel-collection-fragrance-oils" },
    { key: "regular-perfume", label: text("perfume_oils", "Perfume fragrance oils"), handle: "perfume-fragrance-oils" },
    { key: "regular-nature", label: text("nature_oils", "Nature fragrance oils"), handle: "nature-inspired-fragrance-oils" },
    { key: "waterless-oils", label: text("waterless_oils", "Waterless fragrance oils"), handle: "waterless-fragrance-oils-1" },
    { key: "incense-sticks", label: text("incense_sticks", "Handcrafted incense sticks"), handle: "incense-sticks" },
    { key: "perfume-body-oils", label: text("body_oils", "Perfume body oils"), handle: "perfume-body-oils" },
    { key: "bracelets", label: text("bracelets", "Bracelets"), handle: "bracelets" }
  ];

  var FRAGRANCE_OIL_OFFER_GROUPS = ["regular-hotel", "regular-perfume", "regular-nature", "waterless-oils"];

  var CART_GROUPS = [
    { key: "humidifying-diffusers", label: text("humidifying_diffusers", "Humidifying diffusers"), handle: "humidifying-scent-diffusers", recommendations: true },
    { key: "waterless-diffusers", label: text("waterless_diffusers", "Waterless diffusers"), handle: "waterless-scent-diffusers", recommendations: true },
    { key: "sand-candles", label: text("sand_candles", "Sand candles"), handle: "sand-candle" },
    { key: "magic-spell-candles", label: text("magic_spell_candles", "Magic spell candles"), handle: "magic-spell-candles" },
    { key: "incense-holders", label: text("incense_holders", "Incense holders"), handle: "incense-holders" }
  ];

  var DROPPER_ELIGIBLE_COLLECTIONS = [
    { key: "regular-fragrance-oils", handle: "regular-fragrance-oils" },
    { key: "essential-oils", handle: "essential-oils" }
  ];

  function hasFlag() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("ap_cart") === "1") {
        window.localStorage.setItem(FLAG, "1");
        return true;
      }
      if (params.get("ap_cart") === "0") {
        window.localStorage.setItem(FLAG, "0");
        return false;
      }
      return window.localStorage.getItem(FLAG) !== "0";
    } catch (e) {
      return true;
    }
  }

  function shouldOpenOnLoad() {
    try {
      return new URLSearchParams(window.location.search).get("ap_cart_open") === "1";
    } catch (e) {
      return false;
    }
  }

  function rememberCheckoutReturnPath() {
    try {
      window.sessionStorage.setItem(CHECKOUT_RETURN_PATH_KEY, window.location.pathname + window.location.search + window.location.hash);
    } catch (e) {}
  }

  function money(cents) {
    cents = Number(cents || 0);
    var amount = cents / 100;
    return "$" + (Number.isInteger(amount) ? String(amount) : amount.toFixed(2));
  }

  function readPriorityPlusPreference() {
    try {
      var preference = window.sessionStorage.getItem(PRIORITY_PLUS_STATE_KEY);
      return preference === null ? true : preference === "1";
    } catch (e) {
      return true;
    }
  }

  function writePriorityPlusPreference(enabled) {
    state.priorityPlusEnabled = Boolean(enabled);
    try {
      window.sessionStorage.setItem(PRIORITY_PLUS_STATE_KEY, enabled ? "1" : "0");
    } catch (e) {}
  }

  function normalizePrice(value) {
    if (typeof value === "string") {
      value = value.replace(/[^0-9.]/g, "");
      if (value.indexOf(".") !== -1) return Math.round(Number(value) * 100);
    }
    return Number(value || 0);
  }

  function productPrice(product, variant) {
    var price = (variant && variant.price != null) ? variant.price : product && product.price;
    price = normalizePrice(price);
    if (!price) return "";
    return money(price);
  }

  function api(path, options) {
    options = options || {};
    options.credentials = "same-origin";
    options.headers = Object.assign({
      "Accept": "application/json"
    }, options.headers || {});
    return fetch(path, options).then(function (res) {
      if (!res.ok) throw new Error("Cart request failed: " + res.status);
      return res.json();
    });
  }

  function hiddenCartUrl(url) {
    if (!/\/cart\/add(\.js)?(\?|$)/.test(String(url || ""))) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("hide_upez_cart", "true");
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return String(url).indexOf("?") === -1
        ? String(url) + "?hide_upez_cart=true"
        : String(url) + "&hide_upez_cart=true";
    }
  }

  function isCollectionPage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections(\/|$)/i.test(window.location.pathname);
  }

  function isProductPage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(window.location.pathname);
  }

  function shouldOpenAfterAdd() {
    return !isCollectionPage();
  }

  function openOrRefreshAfterAdd() {
    return fetchCart().then(function () {
      if (shouldOpenAfterAdd()) openCart({ skipRefresh: true });
      else bridgeLoyaltyWidget();
      scheduleCartRefresh(700);
    });
  }

  function showError(message) {
    var error = root.querySelector("[data-ap-cart-error]");
    if (!error) return;
    window.clearTimeout(state.errorTimer);
    error.textContent = message || text("update_error", "We couldn't update your cart. Please try again.");
    error.hidden = false;
    state.errorTimer = window.setTimeout(function () {
      error.hidden = true;
    }, 5200);
  }

  function clearError() {
    var error = root.querySelector("[data-ap-cart-error]");
    if (error) error.hidden = true;
    window.clearTimeout(state.errorTimer);
  }

  function setLineBusy(key, busy) {
    root.querySelectorAll("[data-ap-cart-qty]").forEach(function (button) {
      if (button.getAttribute("data-ap-cart-qty") !== key) return;
      button.disabled = busy;
      button.classList.toggle("is-busy", busy);
    });
  }

  function installScrollStyles() {
    if (document.getElementById("ap-cart-scroll-fix")) return;
    var style = document.createElement("style");
    style.id = "ap-cart-scroll-fix";
    style.textContent = [
      ".ap-cart__panel{display:flex!important;flex-direction:column!important;overflow:hidden!important;}",
      ".ap-cart__header,.ap-cart__footer{flex:0 0 auto!important;}",
      ".ap-cart__body{flex:1 1 auto!important;min-height:0!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-y!important;overscroll-behavior:contain!important;}",
      ".ap-cart__items{overflow:visible!important;}"
    ].join("");
    document.head.appendChild(style);
  }

  function installScrollGuards() {
    if (root.__apCartScrollGuards) return;
    root.__apCartScrollGuards = true;
    var lastTouchY = 0;

    function scrollContainer(target) {
      return target && target.closest ? target.closest(".ap-cart__body") : null;
    }

    function canScroll(el) {
      return el && el.scrollHeight > el.clientHeight + 1;
    }

    function atTop(el) {
      return el.scrollTop <= 0;
    }

    function atBottom(el) {
      return el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    }

    root.addEventListener("wheel", function (event) {
      var body = scrollContainer(event.target);
      if (!body) return;
      event.stopPropagation();
      if (!canScroll(body)) {
        event.preventDefault();
        return;
      }
      body.scrollTop += event.deltaY;
      event.preventDefault();
      if ((event.deltaY < 0 && atTop(body)) || (event.deltaY > 0 && atBottom(body))) {
        event.preventDefault();
      }
    }, { passive: false, capture: true });

    root.addEventListener("touchstart", function (event) {
      if (!scrollContainer(event.target) || !event.touches || !event.touches.length) return;
      lastTouchY = event.touches[0].clientY;
    }, { passive: true, capture: true });

    root.addEventListener("touchmove", function (event) {
      var body = scrollContainer(event.target);
      if (!body || !event.touches || !event.touches.length) return;
      var currentY = event.touches[0].clientY;
      var deltaY = lastTouchY - currentY;
      lastTouchY = currentY;
      event.stopPropagation();
      if (!canScroll(body)) {
        event.preventDefault();
        return;
      }
      if ((deltaY < 0 && atTop(body)) || (deltaY > 0 && atBottom(body))) {
        event.preventDefault();
      }
    }, { passive: false, capture: true });
  }

  function fetchCart() {
    if (state.cartFetch) return state.cartFetch;
    state.cartFetch = api(localePath("/cart.js") + "?ap_cart=1&t=" + Date.now()).then(function (cart) {
      state.cart = cart;
      render(cart);
      return cart;
    }).catch(function () {}).finally(function () {
      state.cartFetch = null;
    });
    return state.cartFetch;
  }

  function scheduleCartRefresh(delay) {
    window.clearTimeout(state.refreshTimer);
    state.refreshTimer = window.setTimeout(function () {
      fetchCart().then(bridgeLoyaltyWidget);
    }, delay == null ? 120 : delay);
  }

  function changeLine(key, quantity) {
    return api(localePath("/cart/change.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (cart) {
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      return cart;
    });
  }

  function updateCart(payload) {
    return api(localePath("/cart/update.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (cart) {
      state.cart = cart;
      clearError();
      render(cart);
      document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
      return cart;
    });
  }

  function addVariant(variantId, quantity, properties, sellingPlan) {
    var item = {
      id: Number(variantId),
      quantity: quantity || 1,
      properties: properties || {}
    };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    return api(localePath("/cart/add.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [item]
      })
    }).then(function () {
      clearError();
      return fetchCart();
    });
  }

  function addCartItems(items) {
    return api(localePath("/cart/add.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    });
  }

  function updateCartLines(updates) {
    return api(localePath("/cart/update.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    });
  }

  function oilSize(value) {
    var source = String(value || "");
    var metric = source.match(/(30|60|120|240)\s*ml/i);
    if (metric) return Number(metric[1]);
    var ounces = source.match(/(1|2|4|8)\s*oz/i);
    if (!ounces) return 0;
    return { 1: 30, 2: 60, 4: 120, 8: 240 }[Number(ounces[1])] || 0;
  }

  function oilSizeLabel(value) {
    var source = String(value || "");
    var metric = source.match(/(30|60|120|240)\s*ml/i);
    if (metric) return Number(metric[1]) + "ml";
    var ounces = source.match(/(1|2|4|8)\s*oz/i);
    return ounces ? Number(ounces[1]) + "oz" : "";
  }

  function isMultiPackOilVariant(value) {
    return /(?:[2-9]|\d{2,})\s*[- ]?pack/i.test(String(value || ""));
  }

  function nextOilSize(size) {
    if (size === 30) return 60;
    if (size === 60) return 120;
    if (size === 120) return 240;
    return 0;
  }

  function cartItemHandle(item) {
    if (item && item.handle) return String(item.handle);
    var match = String(item && item.url || "").match(/\/products\/([^?/#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function looksLikeWaterlessOil(item) {
    if (!item) return false;
    var addon = String(item.properties && item.properties._addon || "");
    var identity = [cartItemHandle(item), item.product_title, item.title, addon].join(" ");
    return /waterless.+fragrance.+oil|fragrance.+oil.+waterless/i.test(identity);
  }

  function looksLikeSizeUpgradeableOil(item) {
    if (!item) return false;
    var identity = [cartItemHandle(item), item.product_type, item.product_title, item.title].join(" ");
    var looksLikeOil = looksLikeWaterlessOil(item) || /fragrance.+oil|essential.+oil/i.test(identity);
    return looksLikeOil && (!state.bundleGroupsLoaded || isFragranceOilOfferGroup(bundleGroupKeyForItem(item)));
  }

  function preliminarySizeUpgradeItems(cart) {
    return eligibleItems(cart).filter(function (item) {
      var variantTitle = item.variant_title || item.title;
      return looksLikeSizeUpgradeableOil(item) && !isMultiPackOilVariant(variantTitle) && nextOilSize(oilSize(variantTitle));
    });
  }

  function sizeUpgradeProductUrl(handle) {
    return localePath("/products/" + encodeURIComponent(handle) + ".js");
  }

  function loadSizeUpgradeProducts(cart) {
    var handles = preliminarySizeUpgradeItems(cart).map(cartItemHandle).filter(Boolean);
    var pending = handles.map(function (handle) {
      if (Object.prototype.hasOwnProperty.call(state.sizeUpgradeProducts, handle)) {
        return Promise.resolve(state.sizeUpgradeProducts[handle]);
      }
      if (state.sizeUpgradeLoading[handle]) return state.sizeUpgradeLoading[handle];
      state.sizeUpgradeLoading[handle] = fetch(sizeUpgradeProductUrl(handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).catch(function () {
        return null;
      }).then(function (product) {
        state.sizeUpgradeProducts[handle] = product;
        delete state.sizeUpgradeLoading[handle];
        return product;
      });
      return state.sizeUpgradeLoading[handle];
    });
    return Promise.all(pending).then(function () {
      if (state.cart) renderSizeUpgrade(state.cart);
    });
  }

  function sizeUpgradeProperties(item, targetSize) {
    var properties = Object.assign({}, item.properties || {});
    if (/^Waterless fragrance oil\s+\d+\s*ml$/i.test(String(properties._addon || ""))) {
      properties._addon = "Waterless fragrance oil " + targetSize + "ml";
    }
    return properties;
  }

  function sizeUpgradePropertiesKey(properties) {
    return Object.keys(properties || {}).sort().map(function (key) {
      return JSON.stringify([key, String(properties[key])]);
    }).join("|");
  }

  function sizeUpgradeIdentity(variantId, properties) {
    return String(variantId) + "::" + sizeUpgradePropertiesKey(properties);
  }

  function sizeUpgradeIdentityEntry(variantId, properties) {
    return {
      identity: sizeUpgradeIdentity(variantId, properties),
      variantId: Number(variantId),
      properties: Object.assign({}, properties || {}),
      quantity: 0
    };
  }

  function sizeUpgradeIdentityItems(cart, entry) {
    return (cart.items || []).filter(function (item) {
      return sizeUpgradeIdentity(item.variant_id, item.properties) === entry.identity;
    });
  }

  function sizeUpgradeIdentityQuantity(cart, entry) {
    return sizeUpgradeIdentityItems(cart, entry).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function sizeUpgradeEntriesMatch(cart, entries) {
    return (entries || []).every(function (entry) {
      return sizeUpgradeIdentityQuantity(cart, entry) === Number(entry.quantity || 0);
    });
  }

  function sizeUpgradePlan(cart) {
    if (!state.bundleGroupsLoaded) return null;
    var cartItems = eligibleItems(cart);
    var lines = [];
    var excluded = { max: 0, unavailable: 0, special: 0, total: 0 };
    cartItems.forEach(function (item) {
      var groupKey = bundleGroupKeyForItem(item);
      if (!isFragranceOilOfferGroup(groupKey)) return;
      var fromSize = oilSize(item.variant_title || item.title);
      if (!fromSize) return;
      var itemQuantity = Number(item.quantity || 0);
      if (isMultiPackOilVariant(item.variant_title || item.title) || item.selling_plan_allocation || (item.properties && item.properties._bundle_items_json)) {
        excluded.special += itemQuantity;
        return;
      }
      var toSize = nextOilSize(fromSize);
      if (!toSize) {
        excluded.max += itemQuantity;
        return;
      }
      var handle = cartItemHandle(item);
      var product = state.sizeUpgradeProducts[handle];
      if (!product || !product.variants) {
        excluded.unavailable += itemQuantity;
        return;
      }
      var target = product.variants.find(function (variant) {
        return variant && variant.available !== false && !isMultiPackOilVariant(variant.title) && oilSize(variant.title) === toSize;
      });
      if (!target) {
        excluded.unavailable += itemQuantity;
        return;
      }
      var targetProperties = sizeUpgradeProperties(item, toSize);
      var quantity = itemQuantity;
      var original = Number(item.original_line_price || item.line_price || 0);
      var current = Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0);
      var discountFactor = original > 0 ? current / original : 1;
      var targetOriginal = normalizePrice(target.price) * quantity;
      var targetFinal = Math.round(targetOriginal * discountFactor);
      lines.push({
        key: item.key,
        groupKey: groupKey,
        productId: item.product_id,
        productTitle: item.product_title || item.title,
        fromVariantId: item.variant_id,
        toVariantId: target.id,
        fromSize: fromSize,
        toSize: toSize,
        fromSizeLabel: oilSizeLabel(item.variant_title || item.title) || (fromSize + "ml"),
        toSizeLabel: oilSizeLabel(target.title) || (toSize + "ml"),
        quantity: quantity,
        fromProperties: Object.assign({}, item.properties || {}),
        toProperties: targetProperties,
        fromIdentity: sizeUpgradeIdentity(item.variant_id, item.properties),
        toIdentity: sizeUpgradeIdentity(target.id, targetProperties),
        currentFinal: current,
        currentOriginal: original,
        targetFinal: targetFinal,
        targetOriginal: targetOriginal,
        discountFactor: discountFactor
      });
    });
    excluded.total = excluded.max + excluded.unavailable + excluded.special;
    if (!lines.length) return null;
    var affected = {};
    lines.forEach(function (line) {
      if (!affected[line.fromIdentity]) affected[line.fromIdentity] = sizeUpgradeIdentityEntry(line.fromVariantId, line.fromProperties);
      if (!affected[line.toIdentity]) affected[line.toIdentity] = sizeUpgradeIdentityEntry(line.toVariantId, line.toProperties);
    });
    var snapshot = Object.keys(affected).map(function (identity) {
      var entry = affected[identity];
      entry.quantity = sizeUpgradeIdentityQuantity(cart, entry);
      return entry;
    });
    var desiredByIdentity = {};
    snapshot.forEach(function (entry) {
      desiredByIdentity[entry.identity] = Object.assign({}, entry, { properties: Object.assign({}, entry.properties) });
    });
    lines.forEach(function (line) {
      desiredByIdentity[line.fromIdentity].quantity -= line.quantity;
      desiredByIdentity[line.toIdentity].quantity += line.quantity;
    });
    var desired = Object.keys(desiredByIdentity).map(function (identity) {
      return desiredByIdentity[identity];
    });
    var quantity = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
    var currentTotal = lines.reduce(function (sum, line) { return sum + line.currentFinal; }, 0);
    var targetTotal = lines.reduce(function (sum, line) { return sum + line.targetFinal; }, 0);
    var currentVolume = lines.reduce(function (sum, line) { return sum + (line.fromSize * line.quantity); }, 0);
    var targetVolume = lines.reduce(function (sum, line) { return sum + (line.toSize * line.quantity); }, 0);
    var currentPerMl = currentVolume > 0 ? currentTotal / currentVolume : 0;
    var targetPerMl = targetVolume > 0 ? targetTotal / targetVolume : 0;
    var extraVolume = Math.max(0, targetVolume - currentVolume);
    var delta = targetTotal - currentTotal;
    var regularSavings = lines.reduce(function (sum, line) {
      return sum + Math.max(0, (line.currentOriginal * 2) - line.targetOriginal);
    }, 0);
    var lineDiscountPercents = lines.map(function (line) {
      return line.currentOriginal > 0 ? Math.max(0, Math.round((1 - (line.currentFinal / line.currentOriginal)) * 100)) : 0;
    });
    var hasDiscount = lineDiscountPercents.some(function (percent) { return percent > 0; });
    var commonDiscountPercent = lineDiscountPercents.length && lineDiscountPercents.every(function (percent) {
      return percent === lineDiscountPercents[0];
    }) ? lineDiscountPercents[0] : 0;
    return {
      lines: lines,
      quantity: quantity,
      currentTotal: currentTotal,
      targetTotal: targetTotal,
      delta: delta,
      extraVolume: extraVolume,
      regularSavings: regularSavings,
      unitSavingsPercent: currentPerMl > 0 ? Math.max(0, Math.round((1 - (targetPerMl / currentPerMl)) * 100)) : 0,
      discountPercent: commonDiscountPercent,
      hasDiscount: hasDiscount,
      excluded: excluded,
      totalQuantity: quantity + excluded.total,
      snapshot: snapshot,
      desired: desired,
      sameMove: lines.every(function (line) {
        return line.fromSize === lines[0].fromSize && line.toSize === lines[0].toSize && line.toSizeLabel === lines[0].toSizeLabel;
      })
    };
  }

  function shortOilTitle(value) {
    return String(value || "Fragrance oil")
      .split(/\s+Inspired\b/i)[0]
      .split(/\s+[–-]\s+/)[0]
      .replace(/\s+Waterless Fragrance Oil.*$/i, "")
      .trim();
  }

  function sizeUpgradeDetailTitle(value) {
    var title = shortOilTitle(value).replace(/\s+Perfume$/i, "").trim();
    if (title.length > 28) title = title.replace(/\s+by\s+.+$/i, "").trim();
    return title || text("fragrance_oil", "Fragrance oil");
  }

  function sizeUpgradeDelta(value) {
    if (value <= 0) return text("included", "Included");
    return "+" + money(value);
  }

  function renderSizeUpgradeSkeleton(mount, count) {
    mount.hidden = false;
    mount.className = "ap-cart__size-upgrade is-loading";
    mount.innerHTML = [
      '<div class="ap-cart__size-upgrade-skeleton" aria-label="' + escapeHtml(text("checking_size_upgrades", "Checking size upgrades")) + '">',
        '<span></span><i></i><b></b>',
      '</div>'
    ].join("");
    mount.setAttribute("data-candidate-count", String(count || 0));
  }

  function renderSizeUpgradeSuccess(mount, success) {
    var successTitle = success.quantity === 1
      ? text("bottle_doubled", "Bottle doubled")
      : formatText("bottles_doubled", "__COUNT__ bottles doubled", { count: success.quantity });
    var successCopy = success.toSizeLabel
      ? formatText("bottles_now_size", "Now __SIZE__", { size: success.toSizeLabel })
      : text("bottles_next_sizes", "Next bottle sizes");
    if (success.discountPercent > 0) {
      successCopy += " · " + formatText("discount_still_applies", "__PERCENT__% discount still applies", { percent: success.discountPercent });
    } else if (success.hasDiscount) {
      successCopy += " · " + text("existing_savings_still_apply", "Existing savings still apply");
    }
    var plan = state.sizeUpgradeUndo && state.sizeUpgradeUndo.plan;
    var expanded = Boolean(state.sizeUpgradeExpanded && plan);
    var reviewId = "ap-cart-size-upgrade-success-review";
    mount.hidden = false;
    mount.className = "ap-cart__size-upgrade is-success" + (expanded ? " is-expanded" : "");
    mount.innerHTML = [
      '<div class="ap-cart__size-upgrade-success">',
        '<div class="ap-cart__size-upgrade-success-line"><strong>' + escapeHtml(successTitle) + '</strong><button type="button" data-ap-cart-size-upgrade-undo>' + escapeHtml(text("undo", "Undo")) + '</button></div>',
        '<div class="ap-cart__size-upgrade-success-line"><small>' + escapeHtml(successCopy) + '</small>' + (plan ? '<button class="ap-cart__size-upgrade-success-review" type="button" data-ap-cart-size-upgrade-review aria-expanded="' + (expanded ? "true" : "false") + '" aria-controls="' + reviewId + '">' + escapeHtml(text("details", "Details")) + '</button>' : '') + '</div>',
      '</div>',
      plan ? sizeUpgradeDetailsHtml(plan, reviewId, expanded) : ""
    ].join("");
  }

  function sizeUpgradeDetailsHtml(plan, reviewId, expanded) {
    var exclusionNotes = [];
    if (plan.excluded.max) exclusionNotes.push(formatText("bottles_already_largest", "__COUNT__ already largest", { count: plan.excluded.max }));
    if (plan.excluded.unavailable) exclusionNotes.push(formatText("bottle_size_unavailable", "__COUNT__ next size unavailable", { count: plan.excluded.unavailable }));
    if (plan.excluded.special) exclusionNotes.push(formatText("bottles_special_unchanged", "__COUNT__ bundle or subscription unchanged", { count: plan.excluded.special }));
    var trust = plan.discountPercent > 0
      ? formatText("discount_still_applies", "__PERCENT__% discount still applies", { percent: plan.discountPercent })
      : plan.hasDiscount
        ? text("existing_savings_still_apply", "Existing savings still apply")
        : text("bundle_pricing_recalculates", "Bundle pricing recalculates automatically");
    var detailFacts = exclusionNotes.concat([
      formatText("save_regular_price", "Save __AMOUNT__", { amount: money(plan.regularSavings) }) + " vs same volume",
      formatText("added_volume", "+__VOLUME__ml total", { volume: Math.round(plan.extraVolume) }),
      trust
    ]);
    return [
      '<div class="ap-cart__size-upgrade-list" id="' + reviewId + '"' + (expanded ? "" : " hidden") + '>',
        plan.lines.map(function (line) {
          var quantityLabel = line.quantity > 1 ? " ×" + line.quantity : "";
          return '<div><span>' + escapeHtml(sizeUpgradeDetailTitle(line.productTitle) + quantityLabel) + '</span><strong>' + escapeHtml(line.fromSizeLabel + " → " + line.toSizeLabel) + '</strong></div>';
        }).join(""),
        '<p>' + escapeHtml(detailFacts.join(" · ")) + '</p>',
      '</div>'
    ].join("");
  }

  function renderSizeUpgrade(cart) {
    var mount = root.querySelector("[data-ap-cart-size-upgrade]");
    if (!mount) return;
    var candidates = preliminarySizeUpgradeItems(cart);
    if (!candidates.length) {
      mount.hidden = true;
      mount.innerHTML = "";
      return;
    }
    if (!root.classList.contains("is-open")) {
      mount.hidden = true;
      mount.innerHTML = "";
      return;
    }
    if (state.sizeUpgradeSuccess) {
      if (sizeUpgradeEntriesMatch(cart, state.sizeUpgradeSuccess.entries)) {
        renderSizeUpgradeSuccess(mount, state.sizeUpgradeSuccess);
        return;
      }
      state.sizeUpgradeSuccess = null;
      state.sizeUpgradeUndo = null;
    }
    if (!state.bundleGroupsLoaded) {
      renderSizeUpgradeSkeleton(mount, candidates.length);
      loadBundleGroups().then(function () { return loadSizeUpgradeProducts(state.cart || cart); });
      return;
    }
    var unloaded = candidates.some(function (item) {
      var handle = cartItemHandle(item);
      return handle && !Object.prototype.hasOwnProperty.call(state.sizeUpgradeProducts, handle);
    });
    if (unloaded) {
      renderSizeUpgradeSkeleton(mount, candidates.length);
      loadSizeUpgradeProducts(cart);
      return;
    }
    var plan = sizeUpgradePlan(cart);
    if (!plan) {
      mount.hidden = true;
      mount.innerHTML = "";
      return;
    }
    var offerTitle = plan.quantity === 1
      ? text("double_your_bottle_size", "Double your bottle size")
      : plan.excluded.total
        ? formatText("double_bottle_size_count", "Double __COUNT__ bottle sizes", { count: plan.quantity })
        : text("double_every_bottle_size", "Double every bottle size");
    var savingsLabel = formatText("save_regular_price", "Save __AMOUNT__", { amount: money(plan.regularSavings) });
    var discountBadge = plan.discountPercent > 0
      ? formatText("discount_applies_short", "__PERCENT__% still applies", { percent: plan.discountPercent })
      : plan.hasDiscount
        ? text("savings_stay", "Savings stay")
        : text("pricing_updates", "Pricing updates");
    var addedCost = plan.delta > 0
      ? formatText("amount_added", "__AMOUNT__ added", { amount: sizeUpgradeDelta(plan.delta) })
      : text("no_added_cost", "No added cost");
    var ctaLabel = plan.quantity === 1
      ? text("upgrade_my_bottle", "Upgrade my bottle")
      : plan.excluded.total
        ? formatText("upgrade_bottles", "Upgrade __COUNT__ bottles", { count: plan.quantity })
        : text("upgrade_all_bottles", "Upgrade all bottles");
    var reviewId = "ap-cart-size-upgrade-review";
    var expanded = state.sizeUpgradeExpanded;
    mount.hidden = false;
    mount.className = "ap-cart__size-upgrade" + (expanded ? " is-expanded" : "") + (state.sizeUpgradeBusy ? " is-busy" : "");
    mount.innerHTML = [
      '<div class="ap-cart__size-upgrade-main">',
        '<div class="ap-cart__size-upgrade-headline"><strong>' + escapeHtml(offerTitle) + '</strong><button class="ap-cart__size-upgrade-review" type="button" data-ap-cart-size-upgrade-review aria-label="' + escapeHtml(formatText("review_size_changes", "Review __COUNT__ size changes", { count: plan.quantity })) + '" aria-expanded="' + (expanded ? "true" : "false") + '" aria-controls="' + reviewId + '">' + escapeHtml(text("details", "Details")) + '</button></div>',
        '<div class="ap-cart__size-upgrade-money"><strong>' + escapeHtml(savingsLabel) + '</strong><span>' + escapeHtml(addedCost) + '<small>' + escapeHtml(discountBadge) + '</small></span></div>',
        '<div class="ap-cart__size-upgrade-action">',
          '<button type="button" data-ap-cart-size-upgrade-all' + (state.sizeUpgradeBusy ? ' disabled aria-busy="true"' : '') + '>',
            state.sizeUpgradeBusy ? '<span class="ap-cart__size-upgrade-loading"><i aria-hidden="true"></i>' + escapeHtml(formatText("upgrading_bottles", "Upgrading __COUNT__…", { count: plan.quantity })) + '</span>' : '<span>' + escapeHtml(ctaLabel) + '</span>',
          '</button>',
        '</div>',
      '</div>',
      sizeUpgradeDetailsHtml(plan, reviewId, expanded)
    ].join("");
    mount.__apSizeUpgradePlan = plan;
    if (!mount.__apSizeUpgradeImpression) {
      mount.__apSizeUpgradeImpression = true;
      trackCartEvent("size_upgrade_impression", {
        eligible_lines: plan.lines.length,
        eligible_quantity: plan.quantity,
        delta_price: plan.delta / 100,
        surface: "upgrade_all"
      });
    }
  }

  function commitCartState(cart) {
    state.cart = cart;
    clearError();
    render(cart);
    document.dispatchEvent(new CustomEvent("ap-cart:updated", { bubbles: true, detail: cart }));
    return cart;
  }

  function sizeUpgradePricePreserved(cart, plan, cartBefore) {
    if (!sizeUpgradeEntriesMatch(cart, plan.desired)) return false;
    var actualDelta = Number(cart.total_price || 0) - Number((cartBefore && cartBefore.total_price) || 0);
    var tolerance = Math.max(50, Math.round(Math.abs(plan.delta) * 0.01));
    return actualDelta <= plan.delta + tolerance;
  }

  function sizeUpgradeCart() {
    return api(localePath("/cart.js") + "?ap_cart=1&t=" + Date.now());
  }

  function reconcileSizeUpgradeEntries(entries) {
    return sizeUpgradeCart().then(function (cart) {
      var additions = [];
      entries.forEach(function (entry) {
        var missing = Math.max(0, Number(entry.quantity || 0) - sizeUpgradeIdentityQuantity(cart, entry));
        if (!missing) return;
        additions.push({
          id: Number(entry.variantId),
          quantity: missing,
          properties: Object.assign({}, entry.properties || {})
        });
      });
      return (additions.length ? addCartItems(additions) : Promise.resolve()).then(sizeUpgradeCart);
    }).then(function (cart) {
      var updates = {};
      entries.forEach(function (entry) {
        var desiredQuantity = Math.max(0, Number(entry.quantity || 0));
        var matches = sizeUpgradeIdentityItems(cart, entry);
        if (!matches.length && desiredQuantity) throw new Error("size_upgrade_target_missing");
        if (sizeUpgradeIdentityQuantity(cart, entry) === desiredQuantity && matches.length <= 1) return;
        matches.forEach(function (item, index) {
          updates[item.key] = index === 0 ? desiredQuantity : 0;
        });
      });
      return (Object.keys(updates).length ? updateCartLines(updates) : Promise.resolve(cart));
    }).then(function (cart) {
      if (!sizeUpgradeEntriesMatch(cart, entries)) throw new Error("size_upgrade_quantity_mismatch");
      return cart;
    });
  }

  function executeSizeUpgrade(plan) {
    if (!plan || state.sizeUpgradeBusy) return;
    var cartBefore = null;
    state.sizeUpgradeBusy = true;
    state.sizeUpgradeExpanded = false;
    renderSizeUpgrade(state.cart || { items: [] });
    setCartMutating(true);
    trackCartEvent("size_upgrade_clicked", {
      eligible_lines: plan.lines.length,
      eligible_quantity: plan.quantity,
      delta_price: plan.delta / 100,
      surface: "upgrade_all"
    });
    sizeUpgradeCart().then(function (cart) {
      cartBefore = cart;
      if (!sizeUpgradeEntriesMatch(cart, plan.snapshot)) throw new Error("cart_changed");
      return reconcileSizeUpgradeEntries(plan.desired);
    }).then(function (cart) {
      if (!sizeUpgradePricePreserved(cart, plan, cartBefore)) {
        throw new Error("discount_lost");
      }
      state.sizeUpgradeUndo = { plan: plan };
      state.sizeUpgradeSuccess = {
        quantity: plan.quantity,
        unchanged: plan.excluded.total,
        toSizeLabel: plan.sameMove && !plan.excluded.total ? plan.lines[0].toSizeLabel : "",
        discountPercent: plan.discountPercent,
        hasDiscount: plan.hasDiscount,
        entries: plan.desired.map(function (entry) {
          return Object.assign({}, entry, { properties: Object.assign({}, entry.properties) });
        })
      };
      commitCartState(cart);
      trackCartEvent("size_upgrade_success", {
        upgraded_lines: plan.lines.length,
        upgraded_quantity: plan.quantity,
        delta_price: plan.delta / 100,
        cart_total_after: Number(cart.total_price || 0) / 100,
        surface: "upgrade_all"
      });
    }).catch(function (error) {
      if (error && error.message === "cart_changed") {
        if (cartBefore) commitCartState(cartBefore);
        trackCartEvent("size_upgrade_error", { reason: "cart_changed", surface: "upgrade_all" });
        showError(text("size_upgrade_cart_changed", "Your cart changed. Review the updated upgrade offer and try again."));
        return;
      }
      var reason = error && error.message === "discount_lost" ? "discount_lost" : "swap_failed";
      return reconcileSizeUpgradeEntries(plan.snapshot).then(function (cart) {
        commitCartState(cart);
        trackCartEvent("size_upgrade_error", { reason: reason, surface: "upgrade_all" });
        showError(reason === "discount_lost"
          ? text("size_upgrade_discount_kept", "The final price was higher than promised, so your cart is unchanged.")
          : text("size_upgrade_error", "Couldn't size up every bottle. Your cart is unchanged."));
      }).catch(function () {
        return fetchCart().then(function () {
          trackCartEvent("size_upgrade_error", { reason: "recovery_failed", surface: "upgrade_all" });
          showError(text("size_upgrade_review_error", "We couldn't verify every size change. Please review your cart."));
        });
      });
    }).finally(function () {
      state.sizeUpgradeBusy = false;
      setCartMutating(false);
      if (state.cart) renderSizeUpgrade(state.cart);
    });
  }

  function undoSizeUpgrade() {
    if (!state.sizeUpgradeUndo || state.sizeUpgradeBusy || !state.cart) return;
    var plan = state.sizeUpgradeUndo.plan;
    state.sizeUpgradeBusy = true;
    setCartMutating(true);
    reconcileSizeUpgradeEntries(plan.snapshot).then(function (cart) {
      state.sizeUpgradeUndo = null;
      state.sizeUpgradeSuccess = null;
      state.sizeUpgradeExpanded = false;
      commitCartState(cart);
      trackCartEvent("size_upgrade_undo", {
        upgraded_lines: plan.lines.length,
        upgraded_quantity: plan.quantity,
        surface: "upgrade_all"
      });
    }).catch(function () {
      showError(text("size_upgrade_undo_error", "We couldn't undo the size change. Please try again."));
      return fetchCart();
    }).finally(function () {
      state.sizeUpgradeBusy = false;
      setCartMutating(false);
    });
  }

  function setCartMutating(mutating) {
    window.clearTimeout(state.mutationTimer);
    root.classList.toggle("is-mutating", !!mutating);
    if (mutating) {
      state.mutationTimer = window.setTimeout(function () {
        root.classList.remove("is-mutating");
      }, 900);
    }
  }

  function closeNativeCartDrawer() {
    var nativeDrawer = document.querySelector("cart-drawer");
    if (!nativeDrawer) return;
    if (typeof nativeDrawer.close === "function") nativeDrawer.close();
    nativeDrawer.classList.remove("active");
    nativeDrawer.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
  }

  function openCart(options) {
    if (!root.classList.contains("is-enabled")) return;
    closeNativeCartDrawer();
    var wasOpen = root.classList.contains("is-open");
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("ap-cart-lock");
    if (state.cart) render(state.cart);
    if (!options || !options.skipRefresh) fetchCart().then(bridgeLoyaltyWidget);
    else bridgeLoyaltyWidget();
    startLoyaltyBridgeLoop();
    if (!wasOpen) trackCartEvent("cart_opened", {
      trigger: options && options.trigger ? options.trigger : ""
    });
  }

  function closeCart() {
    var wasOpen = root.classList.contains("is-open");
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ap-cart-lock");
    closeNativeCartDrawer();
    window.clearInterval(state.loyaltyTimer);
    if (wasOpen) trackCartEvent("cart_closed");
  }

  function imageUrl(src, width) {
    if (!src) return "";
    if (src.indexOf("//") === 0) src = window.location.protocol + src;
    try {
      var url = new URL(src);
      url.searchParams.set("width", String(width || 220));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function isProtectionItem(item) {
    var variantId = root.dataset.protectionVariantId;
    if (variantId && item && String(item.variant_id) === String(variantId)) return true;
    var title = String((item && item.product_title) || (item && item.title) || "").toLowerCase();
    return /protected shipping|shipping protection|package protection|free unlimited return|green shipping protection/.test(title);
  }

  function isPriorityPlusItem(item) {
    var variantId = root.dataset.priorityPlusVariantId;
    return Boolean(variantId && item && String(item.variant_id) === String(variantId));
  }

  function eligibleItems(cart) {
    return (cart.items || []).filter(function (item) {
      return !isProtectionItem(item) && !isPriorityPlusItem(item);
    });
  }

  function eligibleCartTotal(cart) {
    return eligibleItems(cart).reduce(function (sum, item) {
      var lineTotal = item.final_line_price != null ? item.final_line_price : item.line_price;
      return sum + Number(lineTotal || 0);
    }, 0);
  }

  function eligibleCartOriginalTotal(cart) {
    return eligibleItems(cart).reduce(function (sum, item) {
      return sum + Number(item.original_line_price || item.line_price || 0);
    }, 0);
  }

  function cartLineByKey(key) {
    var cart = state.cart || { items: [] };
    for (var i = 0; i < (cart.items || []).length; i += 1) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }

  function recommendationSource(recCard) {
    if (!recCard) return { source: "cart_drawer" };
    var bundleTrack = recCard.closest("[data-ap-cart-bundle-suggestions-track]");
    if (bundleTrack) {
      return {
        source: "bundle_suggestion",
        source_key: bundleTrack.getAttribute("data-ap-cart-bundle-suggestions-track") || ""
      };
    }
    var groupTrack = recCard.closest("[data-ap-cart-group-recs-track]");
    if (groupTrack) {
      return {
        source: "collection_pairing",
        source_key: groupTrack.getAttribute("data-ap-cart-group-recs-track") || ""
      };
    }
    if (recCard.closest("[data-ap-cart-recs-track]")) {
      return { source: "curated_pairing" };
    }
    if (recCard.closest("[data-ap-cart-room-mist-track]")) {
      return {
        source: "room_mist_upsell",
        source_key: ROOM_MIST_UPSELL_HANDLE
      };
    }
    var lineCleaner = recCard.closest("[data-ap-cart-line-cleaner]");
    if (lineCleaner) {
      if (lineCleaner.getAttribute("data-ap-cart-rec") === "fragrance-dropper") {
        return {
          source: "fragrance_dropper_upsell",
          source_key: DROPPER_UPSELL_HANDLE
        };
      }
      if (lineCleaner.getAttribute("data-ap-cart-rec") === "waterless-cleaner") {
        return {
          source: "waterless_cleaner_upsell",
          source_key: WATERLESS_CLEANER_UPSELL_HANDLE
        };
      }
      return {
        source: "humidifying_cleaner_upsell",
        source_key: HUMIDIFYING_CLEANER_UPSELL_HANDLE
      };
    }
    return { source: "recommendation" };
  }

  function trackCartEvent(name, payload) {
    try {
      var cart = state.cart || { items: [] };
      var items = eligibleItems(cart);
      var quantity = items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      var body = Object.assign({
        visitor_uuid: window.__ap_visitor || "",
        page: window.location.pathname,
        cart_items: quantity,
        cart_line_count: items.length,
        cart_total: Number(cart.total_price || 0) / 100,
        cart_token: cart.token || "",
        drawer_open: root.classList.contains("is-open"),
        via: "ap_cart_drawer"
      }, payload || {});
      if (typeof window.__APEvent === "function") {
        window.__APEvent(name, body);
        return;
      }
      window.setTimeout(function () {
        try {
          if (typeof window.__APEvent === "function") window.__APEvent(name, body);
        } catch (e) {}
      }, 300);
    } catch (e) {}
  }

  function lineProperties(item) {
    var props = item.properties || {};
    var html = Object.keys(props).filter(function (key) {
      return key.charAt(0) !== "_" && !isHiddenCartProperty(key) && props[key] != null && props[key] !== "";
    }).map(function (key) {
      var labelMap = {
        "Amount": text("property_amount", "Amount"),
        "Tier savings": text("property_tier_savings", "Tier savings"),
        "Free gift": text("property_free_gift", "Free gift"),
        "Pairs with": text("property_pairs_with", "Pairs with")
      };
      var value = String(props[key]);
      if (key === "Free gift") {
        var giftMatch = value.match(/^Matching 30 ml (.+) oil \(included, \$9\.99 value\)$/i);
        if (giftMatch) value = formatText("matching_oil_value", "Matching 30 ml __SCENT__ oil (included, $9.99 value)", { SCENT: giftMatch[1] });
      }
      return escapeHtml(labelMap[key] || key) + ": " + escapeHtml(value);
    }).join("<br>");
    return html ? '<p class="ap-cart__properties">' + html + "</p>" : "";
  }

  function isHiddenCartProperty(key) {
    return /^compatible with\b/i.test(String(key || ""));
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(value));
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function renderShipping(cart) {
    var shipping = root.querySelector("[data-ap-cart-shipping]");
    if (shipping) shipping.hidden = false;
    var threshold = Number(root.dataset.freeShippingThreshold);
    var total = eligibleCartTotal(cart);
    var remaining = Math.max(0, threshold - total);
    var shippingText = root.querySelector("[data-ap-cart-shipping-text]");
    var bar = root.querySelector("[data-ap-cart-shipping-progress]");
    var priority = root.querySelector("[data-ap-cart-priority]");
    if (shippingText) {
      shippingText.innerHTML = remaining === 0
        ? escapeHtml(text("shipping_unlocked", "Unlocked for this order"))
        : escapeHtml(formatText("shipping_away", "__AMOUNT__ away", { amount: money(remaining) }));
    }
    if (bar) {
      bar.style.width = Math.max(0, Math.min(100, Math.round((total / threshold) * 100))) + "%";
    }
    if (priority) priority.hidden = remaining !== 0;
  }

  function renderCompatibilityWarning(cart) {
    var warning = root.querySelector("[data-ap-cart-compat-warning]");
    if (!warning) return;
    var show = hasWaterlessDiffuserWithRegularOil(cart);
    warning.hidden = !show;
    warning.innerHTML = show ? [
      '<div>',
        '<strong>' + escapeHtml(text("check_compatibility", "Check compatibility")) + '</strong>',
        '<p>' + escapeHtml(text("compatibility_copy", "Swap regular oil for waterless oil before using this diffuser.")) + '</p>',
      '</div>',
      '<a href="' + escapeHtml(localePath("/collections/waterless-fragrance-oils-1")) + '">' + escapeHtml(text("shop_waterless_oils", "Shop waterless oils")) + '</a>'
    ].join("") : "";
  }

  function renderItems(cart) {
    var mount = root.querySelector("[data-ap-cart-items]");
    var empty = root.querySelector("[data-ap-cart-empty]");
    var items = eligibleItems(cart);
    var bundleCounts = bundleGroupCounts(cart);
    var accessoryKeys = cartLineAccessoryKeys(items);
    if (!mount) return;
    var bundleScroll = bundleSuggestionScrollState();
    if (empty) empty.hidden = items.length > 0;
    if (!state.bundleGroupsLoaded || !state.cartGroupsLoaded) {
      mount.innerHTML = items.map(function (item) {
        return renderCartItem(item, bundleCounts, true, accessoryKeys);
      }).join("");
      restoreBundleSuggestionScroll(bundleScroll);
      if (root.classList.contains("is-open")) loadCartGrouping();
      else warmCartGrouping();
      return;
    }

    var bundleGroups = {};
    var cartGroups = {};
    var otherItems = [];
    var roomMistInserted = false;
    items.forEach(function (item) {
      var bundleKey = bundleGroupKeyForItem(item);
      var cartKey = cartGroupKeyForItem(item);
      if (bundleKey) {
        if (!bundleGroups[bundleKey]) bundleGroups[bundleKey] = [];
        bundleGroups[bundleKey].push(item);
        return;
      }
      if (cartKey) {
        if (!cartGroups[cartKey]) cartGroups[cartKey] = [];
        cartGroups[cartKey].push(item);
        return;
      }
      otherItems.push(item);
    });

    var html = [];
    var hasCartGroupItems = CART_GROUPS.some(function (group) {
      return cartGroups[group.key] && cartGroups[group.key].length;
    });
    BUNDLE_GROUPS.forEach(function (group) {
      if (!bundleGroups[group.key] || !bundleGroups[group.key].length) return;
      var includeRoomMist = !hasCartGroupItems && !roomMistInserted;
      html.push(renderBundleItemGroup(group, bundleGroups[group.key], bundleCounts[group.key] || 0, includeRoomMist, accessoryKeys));
      if (includeRoomMist) roomMistInserted = true;
    });
    CART_GROUPS.forEach(function (group) {
      if (!cartGroups[group.key] || !cartGroups[group.key].length) return;
      var includeRoomMist = !roomMistInserted;
      html.push(renderCartItemGroup(group, cartGroups[group.key], setupNudgeForGroup(group, bundleGroups), includeRoomMist, accessoryKeys));
      if (includeRoomMist) roomMistInserted = true;
    });
    if (otherItems.length) html.push(renderCartItemGroup({ label: text("other_items", "Other items") }, otherItems, "", !roomMistInserted, accessoryKeys));
    mount.innerHTML = html.join("");
    restoreBundleSuggestionScroll(bundleScroll);
  }

  function cartLineAccessoryKeys(items) {
    var keys = {};
    (items || []).forEach(function (item) {
      if (!item || !item.key) return;
      var groupKey = cartGroupKeyForItem(item);
      if ((groupKey === "humidifying-diffusers" || groupKey === "waterless-diffusers") && !keys[groupKey]) {
        keys[groupKey] = item.key;
      }
      if (!keys.dropper && dropperEligibleForItem(item)) {
        keys.dropper = item.key;
      }
    });
    return keys;
  }

  function bundleSuggestionScrollState() {
    var scroll = {};
    root.querySelectorAll("[data-ap-cart-bundle-suggestions-track]").forEach(function (track) {
      var groupKey = track.getAttribute("data-ap-cart-bundle-suggestions-track");
      if (groupKey) scroll[groupKey] = track.scrollLeft || 0;
    });
    return scroll;
  }

  function restoreBundleSuggestionScroll(scroll) {
    Object.keys(scroll || {}).forEach(function (groupKey) {
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (track) track.scrollLeft = scroll[groupKey];
    });
  }

  function renderCartItem(item, bundleCounts, showBundleBadge, accessoryKeys) {
    var accessory = lineAccessoryInline(item, accessoryKeys);
    var price = linePriceHtml(item, bundleCounts);
    var variant = item.variant_title && item.variant_title !== "Default Title"
      ? '<p class="ap-cart__variant">' + escapeHtml(item.variant_title) + "</p>"
      : "";
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? '<p class="ap-cart__plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name || text("subscription", "Subscription")) + "</p>"
      : "";
    var bundleBadge = showBundleBadge ? bundleLineBadge(item, bundleCounts) : "";
    return [
      '<article class="ap-cart__item" data-ap-cart-line="' + escapeHtml(item.key) + '">',
        item.image
          ? '<img class="ap-cart__image" src="' + escapeHtml(imageUrl(item.image, 220)) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">'
          : '<div class="ap-cart__image ap-cart__image--empty" aria-hidden="true"><span></span></div>',
        '<div class="ap-cart__item-main">',
          '<div class="ap-cart__item-top">',
            '<div>',
              '<a class="ap-cart__item-title" href="' + escapeHtml(localePath(item.url || "#")) + '">' + escapeHtml(item.product_title || item.title) + "</a>",
              '<div class="ap-cart__line-detail-row">',
                '<div class="ap-cart__line-meta">',
                  variant,
                  plan,
                  lineProperties(item),
                  price,
                '</div>',
                accessory,
              '</div>',
            '</div>',
            '<div class="ap-cart__item-actions">',
              '<div class="ap-cart__qty" aria-label="' + escapeHtml(text("quantity", "Quantity")) + '">',
                '<button type="button" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity) - 1) + '" aria-label="' + escapeHtml(text("decrease_quantity", "Decrease quantity")) + '">-</button>',
                '<span>' + Number(item.quantity || 0) + '</span>',
                '<button type="button" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity) + 1) + '" aria-label="' + escapeHtml(text("increase_quantity", "Increase quantity")) + '">+</button>',
              '</div>',
              '<button type="button" class="ap-cart__remove" data-ap-cart-qty="' + escapeHtml(item.key) + '" data-qty="0" aria-label="' + escapeHtml(formatText("remove_product", "Remove __PRODUCT__", { product: item.product_title || item.title })) + '">',
                '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="m19 6-1 14H6L5 6"/><path d="M10 11v5"/><path d="M14 11v5"/></svg>',
              '</button>',
            '</div>',
          '</div>',
          bundleBadge,
        '</div>',
      '</article>'
    ].join("");
  }

  function lineAccessoryInline(item, accessoryKeys) {
    var groupKey = cartGroupKeyForItem(item);
    if (groupKey === "humidifying-diffusers") return accessoryKeys && accessoryKeys[groupKey] === item.key ? humidifyingCleanerInline() : "";
    if (groupKey === "waterless-diffusers") return accessoryKeys && accessoryKeys[groupKey] === item.key ? waterlessCleanerInline() : "";
    if (!accessoryKeys || accessoryKeys.dropper !== item.key) return "";
    return dropperInline(item);
  }

  function dropperInline(item) {
    if (!dropperEligibleForItem(item)) return "";
    if (state.dropperUnavailable) return "";
    if (state.cart && cartHasProduct(state.cart, state.dropperProduct && state.dropperProduct.id)) return "";
    if (!state.dropperProduct) {
      loadDropperUpsell().then(function () {
        if (state.cart) render(state.cart);
      });
      return "";
    }
    var product = state.dropperProduct;
    var variant = product && product.variants && product.variants[0];
    if (!product || product.available === false || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__line-cleaner ap-cart__line-cleaner--dropper" data-ap-cart-line-cleaner data-ap-cart-rec="fragrance-dropper" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__line-cleaner-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 120)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__line-cleaner-main">',
          '<a class="ap-cart__line-cleaner-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(text("dropper", "Dropper")) + (price ? ' · ' + escapeHtml(price) : '') + '</a>',
          '<p>' + escapeHtml(text("dropper_copy", "Precise drops · no drip, no waste")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__line-cleaner-add" data-ap-cart-add-rec="fragrance-dropper" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">+</button>',
      '</article>'
    ].join("");
  }

  function dropperEligibleForItem(item) {
    if (!item || !item.product_id) return false;
    if (state.dropperProduct && String(item.product_id) === String(state.dropperProduct.id)) return false;
    if (!state.dropperEligibleLoaded) {
      loadDropperEligibleProducts().then(function () {
        if (state.cart) render(state.cart);
      });
      return false;
    }
    return Boolean(state.dropperEligibleProducts[String(item.product_id)]);
  }

  function humidifyingCleanerInline() {
    if (state.humidifyingCleanerUnavailable) return "";
    if (state.cart && cartHasProduct(state.cart, state.humidifyingCleanerProduct && state.humidifyingCleanerProduct.id)) return "";
    if (!state.humidifyingCleanerProduct) {
      loadHumidifyingCleanerUpsell().then(function () {
        if (state.cart) render(state.cart);
      });
      return "";
    }
    var product = state.humidifyingCleanerProduct;
    var variant = product && product.variants && product.variants[0];
    if (!product || product.available === false || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__line-cleaner" data-ap-cart-line-cleaner data-ap-cart-rec="humidifying-cleaner" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__line-cleaner-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 120)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__line-cleaner-main">',
          '<a class="ap-cart__line-cleaner-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(text("diffuser_cleaner", "Diffuser cleaner")) + '</a>',
          '<p><strong>' + (price ? escapeHtml(price) : "") + '</strong> · ' + escapeHtml(text("removes_buildup", "removes buildup")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__line-cleaner-add" data-ap-cart-add-rec="humidifying-cleaner" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">+</button>',
      '</article>'
    ].join("");
  }

  function waterlessCleanerInline() {
    if (state.waterlessCleanerUnavailable) return "";
    if (state.cart && cartHasProduct(state.cart, state.waterlessCleanerProduct && state.waterlessCleanerProduct.id)) return "";
    if (!state.waterlessCleanerProduct) {
      loadWaterlessCleanerUpsell().then(function () {
        if (state.cart) render(state.cart);
      });
      return "";
    }
    var product = state.waterlessCleanerProduct;
    var variant = product && product.variants && product.variants[0];
    if (!product || product.available === false || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__line-cleaner" data-ap-cart-line-cleaner data-ap-cart-rec="waterless-cleaner" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__line-cleaner-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 120)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__line-cleaner-main">',
          '<a class="ap-cart__line-cleaner-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(text("diffuser_cleaner", "Diffuser cleaner")) + '</a>',
          '<p><strong>' + (price ? escapeHtml(price) : "") + '</strong> · ' + escapeHtml(text("removes_buildup", "removes buildup")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__line-cleaner-add" data-ap-cart-add-rec="waterless-cleaner" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">+</button>',
      '</article>'
    ].join("");
  }

  function loadHumidifyingCleanerUpsell() {
    if (state.humidifyingCleanerProduct || state.humidifyingCleanerUnavailable) return Promise.resolve(state.humidifyingCleanerProduct);
    if (state.humidifyingCleanerLoading) return state.humidifyingCleanerLoading;
    state.humidifyingCleanerLoading = fetch(localePath("/products/" + encodeURIComponent(HUMIDIFYING_CLEANER_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (product) {
      if (!product || product.available === false || !product.variants || !product.variants.length) {
        state.humidifyingCleanerUnavailable = true;
        return null;
      }
      state.humidifyingCleanerProduct = product;
      return product;
    }).catch(function () {
      state.humidifyingCleanerUnavailable = true;
      return null;
    }).finally(function () {
      state.humidifyingCleanerLoading = null;
    });
    return state.humidifyingCleanerLoading;
  }

  function loadWaterlessCleanerUpsell() {
    if (state.waterlessCleanerProduct || state.waterlessCleanerUnavailable) return Promise.resolve(state.waterlessCleanerProduct);
    if (state.waterlessCleanerLoading) return state.waterlessCleanerLoading;
    state.waterlessCleanerLoading = fetch(localePath("/products/" + encodeURIComponent(WATERLESS_CLEANER_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Waterless cleaner product unavailable");
      return response.json();
    }).then(function (product) {
      if (!product || !product.available) {
        state.waterlessCleanerUnavailable = true;
        return null;
      }
      state.waterlessCleanerProduct = product;
      return product;
    }).catch(function () {
      state.waterlessCleanerUnavailable = true;
      return null;
    }).finally(function () {
      state.waterlessCleanerLoading = null;
    });
    return state.waterlessCleanerLoading;
  }

  function loadDropperUpsell() {
    if (state.dropperProduct || state.dropperUnavailable) return Promise.resolve(state.dropperProduct);
    if (state.dropperLoading) return state.dropperLoading;
    state.dropperLoading = fetch(localePath("/products/" + encodeURIComponent(DROPPER_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Dropper product unavailable");
      return response.json();
    }).then(function (product) {
      if (!product || !product.available || !product.variants || !product.variants.length) {
        state.dropperUnavailable = true;
        return null;
      }
      state.dropperProduct = product;
      return product;
    }).catch(function () {
      state.dropperUnavailable = true;
      return null;
    }).finally(function () {
      state.dropperLoading = null;
    });
    return state.dropperLoading;
  }

  function linePriceHtml(item, bundleCounts) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = lineDiscountAmount(item, bundleCounts);
    var displayFinal = discount > 0 && original > discount ? original - discount : final || original;
    var compare = discount > 0 && original > displayFinal
      ? '<span class="ap-cart__compare">' + money(original) + "</span>"
      : "";
    var discountLabel = discount > 0 ? lineDiscountLabel(item, discount, original) : "";
    return [
      '<div class="ap-cart__price-row">',
        '<span class="ap-cart__price">' + money(displayFinal) + "</span>",
        compare,
        discountLabel,
      '</div>'
    ].join("");
  }

  function lineDiscountAmount(item, bundleCounts) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = Math.max(0, original - final);
    discount = Math.max(discount, Number(item.line_level_total_discount || 0), Number(item.total_discount || 0));
    var allocated = 0;
    (item.discount_allocations || []).forEach(function (allocation) {
      allocated += Number(allocation.amount || 0);
    });
    return Math.max(discount, allocated, estimatedBundleDiscountAmount(item, bundleCounts));
  }

  function actualLineDiscountAmount(item) {
    var original = Number(item.original_line_price || 0);
    var final = Number(item.final_line_price || 0);
    var discount = Math.max(0, original - final);
    discount = Math.max(discount, Number(item.line_level_total_discount || 0), Number(item.total_discount || 0));
    var allocated = 0;
    (item.discount_allocations || []).forEach(function (allocation) {
      allocated += Number(allocation.amount || 0);
    });
    return Math.max(discount, allocated);
  }

  function estimatedBundleDiscountAmount(item, bundleCounts) {
    if (!bundleCounts) return 0;
    var groupKey = bundleGroupKeyForItem(item);
    if (!groupKey) return 0;
    var tier = bundleTier(bundleCounts[groupKey] || 0, groupKey);
    if (!tier.percent) return 0;
    return Math.round(Number(item.original_line_price || 0) * tier.percent / 100);
  }

  function lineDiscountLabel(item, discount, original) {
    var percent = original > 0 ? Math.round((discount / original) * 100) : 0;
    var label = percent >= 1
      ? formatText("percent_off", "__PERCENT__% off", { percent: percent })
      : formatText("save_amount", "Save __AMOUNT__", { amount: money(discount) });
    return '<span class="ap-cart__saving">' + escapeHtml(label) + "</span>";
  }

  function renderBundleItemGroup(group, items, count, includeRoomMist, accessoryKeys) {
    var counts = {};
    counts[group.key] = count;
    return [
      '<section class="ap-cart__bundle-group">',
        bundleGroupHeader(group, count),
        bundleSuggestionShell(group, count),
        items.map(function (item) {
          return renderCartItem(item, counts, false, accessoryKeys);
        }).join(""),
        includeRoomMist ? roomMistUpsellShell() : "",
      '</section>'
    ].join("");
  }

  function bundleSuggestionShell(group, count) {
    if (!group || !group.handle || count >= 5) return "";
    var cachedHtml = state.bundleSuggestionHtml[group.key] || "";
    var hidden = cachedHtml ? "" : " hidden";
    return [
      '<section class="ap-cart__recs ap-cart__recs--bundle" data-ap-cart-bundle-suggestions="' + escapeHtml(group.key) + '" data-ap-cart-bundle-handle="' + escapeHtml(group.handle) + '"' + hidden + '>',
        '<div class="ap-cart__recs-heading">',
          '<div><span class="ap-cart__recs-kicker">' + escapeHtml(text("add_to_unlock_savings", "Add to unlock savings")) + '</span></div>',
          '<div class="ap-cart__recs-nav" aria-label="' + escapeHtml(formatText("suggestions_navigation", "__GROUP__ suggestions navigation", { group: compactBundleLabel(group) })) + '">',
            '<button type="button" data-ap-cart-bundle-suggestions-prev="' + escapeHtml(group.key) + '" aria-label="' + escapeHtml(text("previous_suggestions", "Previous suggestions")) + '">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
            '</button>',
            '<button type="button" data-ap-cart-bundle-suggestions-next="' + escapeHtml(group.key) + '" aria-label="' + escapeHtml(text("next_suggestions", "Next suggestions")) + '">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
            '</button>',
          '</div>',
        '</div>',
        '<div class="ap-cart__recs-track" data-ap-cart-bundle-suggestions-track="' + escapeHtml(group.key) + '">' + cachedHtml + '</div>',
      '</section>'
    ].join("");
  }

  function renderCartItemGroup(group, items, setupNudge, includeRoomMist, accessoryKeys) {
    var recs = group.recommendations ? groupRecommendationShell(group, items) : "";
    return [
      '<section class="ap-cart__item-group">',
        '<div class="ap-cart__item-group-head">',
          '<span>' + escapeHtml(group.label || text("items", "Items")) + '</span>',
          '<strong>' + itemGroupCount(items) + '</strong>',
        '</div>',
        items.map(function (item) {
          return renderCartItem(item, {}, false, accessoryKeys);
        }).join(""),
        setupNudge || "",
        includeRoomMist ? roomMistUpsellShell() : "",
        recs,
      '</section>'
    ].join("");
  }

  function roomMistUpsellShell() {
    return "";
  }

  function setupNudgeForGroup(group, bundleGroups) {
    var key = group && group.key;
    if (key === "humidifying-diffusers" && !hasAnyBundleGroup(bundleGroups, ["regular-hotel", "regular-perfume", "regular-nature"])) {
      return setupNudgeHtml(text("complete_setup", "Complete your setup"), text("humidifying_setup", "Add a compatible humidifying oil for your diffuser."));
    }
    if (key === "waterless-diffusers" && !hasAnyBundleGroup(bundleGroups, ["waterless-oils"])) {
      return setupNudgeHtml(text("complete_setup", "Complete your setup"), text("waterless_setup", "Add a waterless fragrance oil for your cold-air diffuser."));
    }
    return "";
  }

  function hasAnyBundleGroup(bundleGroups, keys) {
    return keys.some(function (key) {
      return bundleGroups[key] && bundleGroups[key].length;
    });
  }

  function setupNudgeHtml(title, copy) {
    return [
      '<div class="ap-cart__setup-nudge">',
        '<span>' + escapeHtml(title) + '</span>',
        '<p>' + escapeHtml(copy) + '</p>',
      '</div>'
    ].join("");
  }

  function groupRecommendationShell(group, items) {
    var source = (items || []).find(function (item) {
      return item && item.product_id;
    });
    if (!source) return "";
    return [
      '<section class="ap-cart__recs ap-cart__recs--group" data-ap-cart-group-recs="' + escapeHtml(group.key) + '" data-ap-cart-group-recs-source="' + escapeHtml(source.product_id) + '" hidden>',
        '<div class="ap-cart__recs-heading">',
          '<div><span class="ap-cart__recs-kicker">' + escapeHtml(text("curated_pairings", "Curated pairings")) + '</span></div>',
          '<div class="ap-cart__recs-nav" aria-label="' + escapeHtml(formatText("group_recommendation_navigation", "__GROUP__ recommendation navigation", { group: group.label || "Recommendation" })) + '">',
            '<button type="button" data-ap-cart-group-recs-prev="' + escapeHtml(group.key) + '" aria-label="' + escapeHtml(text("previous_recommendations", "Previous recommendations")) + '">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
            '</button>',
            '<button type="button" data-ap-cart-group-recs-next="' + escapeHtml(group.key) + '" aria-label="' + escapeHtml(text("next_recommendations", "Next recommendations")) + '">',
              '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
            '</button>',
          '</div>',
        '</div>',
        '<div class="ap-cart__recs-track" data-ap-cart-group-recs-track="' + escapeHtml(group.key) + '"></div>',
      '</section>'
    ].join("");
  }

  function itemGroupCount(items) {
    return (items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function bundleGroupHeader(group, count) {
    var isFragranceOilOffer = isFragranceOilOfferGroup(group);
    var goal = isFragranceOilOffer ? 7 : 5;
    var width = Math.min(100, Math.round((Math.min(count, goal) / goal) * 100));
    return [
      '<div class="ap-cart__bundle-group-head">',
        '<div class="ap-cart__bundle-group-meta">',
          '<span>' + escapeHtml(compactBundleLabel(group)) + '</span>',
          '<strong>' + count + '/' + goal + '</strong>',
        '</div>',
        '<div class="ap-cart__bundle-group-bar' + (isFragranceOilOffer ? ' ap-cart__bundle-group-bar--fragrance-oils' : '') + '" style="--ap-progress:' + width + '%" aria-hidden="true">',
          '<i class="ap-cart__bundle-goal ap-cart__bundle-goal--three"></i>',
          '<i class="ap-cart__bundle-goal ap-cart__bundle-goal--five"></i>',
          isFragranceOilOffer ? '<i class="ap-cart__bundle-goal ap-cart__bundle-goal--seven"></i>' : '',
          '<span></span>',
        '</div>',
        '<p>' + escapeHtml(bundleGroupProgressCopy(group, count)) + '</p>',
      '</div>'
    ].join("");
  }

  function collectionProductsUrl(handle) {
    return localePath("/collections/" + encodeURIComponent(handle) + "/products.json") + "?limit=250";
  }

  function readBundleGroupCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(BUNDLE_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.groups) return false;
      state.bundleProductGroups = cached.groups;
      state.bundleGroupsLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeBundleGroupCache() {
    try {
      window.localStorage.setItem(BUNDLE_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        groups: state.bundleProductGroups
      }));
    } catch (e) {}
  }

  function readCartGroupCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(CART_GROUP_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.groups) return false;
      state.cartProductGroups = cached.groups;
      state.cartGroupsLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeCartGroupCache() {
    try {
      window.localStorage.setItem(CART_GROUP_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        groups: state.cartProductGroups
      }));
    } catch (e) {}
  }

  function readDropperEligibleCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(DROPPER_ELIGIBLE_CACHE_KEY) || "null");
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > 86400000 || !cached.products) return false;
      state.dropperEligibleProducts = cached.products;
      state.dropperEligibleLoaded = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function writeDropperEligibleCache() {
    try {
      window.localStorage.setItem(DROPPER_ELIGIBLE_CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        products: state.dropperEligibleProducts
      }));
    } catch (e) {}
  }

  function loadDropperEligibleProducts() {
    if (state.dropperEligibleLoaded) return Promise.resolve(state.dropperEligibleProducts);
    if (readDropperEligibleCache()) return Promise.resolve(state.dropperEligibleProducts);
    if (state.dropperEligibleLoading) return state.dropperEligibleLoading;
    state.dropperEligibleLoading = Promise.all(DROPPER_ELIGIBLE_COLLECTIONS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          state.dropperEligibleProducts[String(product.id)] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.dropperEligibleLoaded = true;
      state.dropperEligibleLoading = null;
      writeDropperEligibleCache();
      if (state.cart) render(state.cart);
      return state.dropperEligibleProducts;
    });
    return state.dropperEligibleLoading;
  }

  function loadCartGroups() {
    if (state.cartGroupsLoaded) return Promise.resolve(state.cartProductGroups);
    if (readCartGroupCache()) return Promise.resolve(state.cartProductGroups);
    if (state.cartGroupsLoading) return state.cartGroupsLoading;
    state.cartGroupsLoading = Promise.all(CART_GROUPS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          var id = String(product.id);
          if (!state.cartProductGroups[id]) state.cartProductGroups[id] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.cartGroupsLoaded = true;
      state.cartGroupsLoading = null;
      writeCartGroupCache();
      if (state.cart) render(state.cart);
      return state.cartProductGroups;
    });
    return state.cartGroupsLoading;
  }

  function loadCartGrouping() {
    return Promise.all([loadBundleGroups(), loadCartGroups(), loadDropperEligibleProducts()]);
  }

  function warmCartGrouping() {
    if (state.bundleGroupsLoaded && state.cartGroupsLoaded && state.dropperEligibleLoaded) return;
    if ((state.bundleGroupsLoaded || state.bundleGroupsLoading) && (state.cartGroupsLoaded || state.cartGroupsLoading) && (state.dropperEligibleLoaded || state.dropperEligibleLoading)) return;
    window.setTimeout(loadCartGrouping, 500);
  }

  function loadBundleGroups() {
    if (state.bundleGroupsLoaded) return Promise.resolve(state.bundleProductGroups);
    if (readBundleGroupCache()) return Promise.resolve(state.bundleProductGroups);
    if (state.bundleGroupsLoading) return state.bundleGroupsLoading;
    state.bundleGroupsLoading = Promise.all(BUNDLE_GROUPS.map(function (group) {
      return fetch(collectionProductsUrl(group.handle), {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        products.forEach(function (product) {
          if (!product || !product.id) return;
          var id = String(product.id);
          if (!state.bundleProductGroups[id]) state.bundleProductGroups[id] = group.key;
        });
      }).catch(function () {});
    })).then(function () {
      state.bundleGroupsLoaded = true;
      state.bundleGroupsLoading = null;
      writeBundleGroupCache();
      if (state.cart) render(state.cart);
      return state.bundleProductGroups;
    });
    return state.bundleGroupsLoading;
  }

  function bundleGroupByKey(key) {
    return BUNDLE_GROUPS.find(function (group) {
      return group.key === key;
    }) || null;
  }

  function bundleGroupKeyForItem(item) {
    if (!item) return "";
    if (!item.product_id) return "";
    return state.bundleProductGroups[String(item.product_id)] || "";
  }

  function cartGroupKeyForItem(item) {
    if (!item) return "";
    if (!item.product_id) return "";
    return state.cartProductGroups[String(item.product_id)] || "";
  }

  function hasWaterlessDiffuserWithRegularOil(cart) {
    if (!state.bundleGroupsLoaded || !state.cartGroupsLoaded) return false;
    var hasWaterlessDiffuser = false;
    var hasRegularOil = false;
    eligibleItems(cart).forEach(function (item) {
      if (cartGroupKeyForItem(item) === "waterless-diffusers") hasWaterlessDiffuser = true;
      if (["regular-hotel", "regular-perfume", "regular-nature"].indexOf(bundleGroupKeyForItem(item)) !== -1) hasRegularOil = true;
    });
    return hasWaterlessDiffuser && hasRegularOil;
  }

  function bundleGroupCounts(cart) {
    var counts = {};
    eligibleItems(cart).forEach(function (item) {
      var groupKey = bundleGroupKeyForItem(item);
      if (!groupKey) return;
      counts[groupKey] = (counts[groupKey] || 0) + Number(item.quantity || 0);
    });
    return counts;
  }

  function isFragranceOilOfferGroup(group) {
    var key = typeof group === "string" ? group : group && group.key;
    return FRAGRANCE_OIL_OFFER_GROUPS.indexOf(key) !== -1;
  }

  function bundleTier(count, group) {
    if (isFragranceOilOfferGroup(group)) {
      if (count >= 7) return { percent: 20, next: 0, target: 7 };
      if (count >= 5) return { percent: 15, next: 7 - count, target: 7 };
      if (count >= 3) return { percent: 10, next: 5 - count, target: 5 };
      return { percent: 0, next: 3 - count, target: 3 };
    }
    if (count >= 5) return { percent: 20, next: 0, target: 5 };
    if (count >= 3) return { percent: 15, next: 5 - count, target: 5 };
    return { percent: 0, next: 3 - count, target: 3 };
  }

  function bundleProgressCopy(count, group) {
    var tier = bundleTier(count, group);
    if (isFragranceOilOfferGroup(group)) {
      if (tier.percent === 20) return formatText("bundle_progress", "__PERCENT__% unlocked", { percent: 20 });
      if (tier.percent === 15) return formatText("bundle_progress_next", "__PERCENT__% unlocked · __COUNT__ to __NEXT_PERCENT__%", { percent: 15, count: tier.next, next_percent: 20 });
      if (tier.percent === 10) return formatText("bundle_progress_next", "__PERCENT__% unlocked · __COUNT__ to __NEXT_PERCENT__%", { percent: 10, count: tier.next, next_percent: 15 });
      return formatText("bundle_progress_start", "__COUNT__ to __PERCENT__%", { count: tier.next, percent: 10 });
    }
    if (tier.percent === 20) return formatText("bundle_progress", "__PERCENT__% unlocked", { percent: 20 });
    if (tier.percent === 15) {
      return formatText("bundle_progress_next", "__PERCENT__% unlocked · __COUNT__ to __NEXT_PERCENT__%", { percent: 15, count: tier.next, next_percent: 20 });
    }
    return formatText("bundle_progress_start", "__COUNT__ to __PERCENT__%", { count: tier.next, percent: 15 });
  }

  function bundleGroupProgressCopy(group, count) {
    var tier = bundleTier(count, group);
    var noun = bundleGroupNoun(group);
    if (isFragranceOilOfferGroup(group)) {
      if (tier.percent === 20) return formatText("bundle_discount_unlocked", "__PERCENT__% off unlocked on __GROUP__", { percent: 20, group: noun });
      if (tier.percent === 15) return formatText("bundle_discount_next", "__PERCENT__% off unlocked · Add __COUNT__ more __GROUP__ for __NEXT_PERCENT__% off", { percent: 15, count: tier.next, group: noun, next_percent: 20 });
      if (tier.percent === 10) return formatText("bundle_discount_next", "__PERCENT__% off unlocked · Add __COUNT__ more __GROUP__ for __NEXT_PERCENT__% off", { percent: 10, count: tier.next, group: noun, next_percent: 15 });
      return formatText("bundle_discount_start", "Add __COUNT__ more __GROUP__ for __PERCENT__% off", { count: tier.next, group: noun, percent: 10 });
    }
    if (tier.percent === 20) return formatText("bundle_discount_unlocked", "__PERCENT__% off unlocked on __GROUP__", { percent: 20, group: noun });
    if (tier.percent === 15) {
      return formatText("bundle_discount_next", "__PERCENT__% off unlocked · Add __COUNT__ more __GROUP__ for __NEXT_PERCENT__% off", { percent: 15, count: tier.next, group: noun, next_percent: 20 });
    }
    return formatText("bundle_discount_start", "Add __COUNT__ more __GROUP__ for __PERCENT__% off", { count: tier.next, group: noun, percent: 15 });
  }

  function bundleGroupNoun(group) {
    var key = group && group.key;
    if (key === "regular-hotel") return text("hotel_scents", "hotel scents");
    if (key === "regular-perfume") return text("perfume_scents", "perfume scents");
    if (key === "regular-nature") return text("nature_scents", "nature scents");
    if (key === "waterless-oils") return text("waterless_scents", "waterless scents");
    if (key === "incense-sticks") return text("incense", "incense");
    if (key === "perfume-body-oils") return text("body_oils", "body oils").toLowerCase();
    if (key === "bracelets") return text("bracelets", "bracelets").toLowerCase();
    return String(group && group.label || text("scents", "scents")).toLowerCase();
  }

  function bundleLineBadge(item, counts) {
    if (!item) return "";
    var groupKey = bundleGroupKeyForItem(item);
    var group = bundleGroupByKey(groupKey);
    if (!group) return "";
    var count = counts[groupKey] || 0;
    var tier = bundleTier(count, group);
    var label = tier.percent
      ? formatText("bundle_discount", "__PERCENT__% bundle discount", { percent: tier.percent })
      : formatText("bundle_offer", "Bundle offer · __PROGRESS__", { progress: bundleProgressCopy(count, group) });
    return [
      '<p class="ap-cart__bundle-line">',
        '<span>' + escapeHtml(compactBundleLabel(group)) + '</span>',
        '<strong>' + escapeHtml(label) + '</strong>',
      '</p>'
    ].join("");
  }

  function compactBundleLabel(group) {
    var key = group && group.key;
    if (key === "regular-hotel") return text("hotel_bundle", "Hotel Bundle");
    if (key === "regular-perfume") return text("perfume_bundle", "Perfume Bundle");
    if (key === "regular-nature") return text("nature_bundle", "Nature Bundle");
    if (key === "waterless-oils") return text("waterless_bundle", "Waterless Bundle");
    if (key === "incense-sticks") return text("incense_bundle", "Incense Bundle");
    if (key === "perfume-body-oils") return text("body_oil_bundle", "Body Oil Bundle");
    if (key === "bracelets") return text("bracelets_bundle", "Bracelets Bundle");
    return String(group && group.label || "")
      .replace(/\s+fragrance oils?$/i, "")
      .replace(/\s+oils?$/i, "")
      .replace(/\s+sticks?$/i, "")
      .trim() + " Bundle";
  }

  function renderBundleProgress(cart) {
    var mount = root.querySelector("[data-ap-cart-bundle-progress]");
    if (!mount) return;
    mount.hidden = true;
    mount.innerHTML = "";
    if (!state.bundleGroupsLoaded) {
      if (root.classList.contains("is-open")) loadBundleGroups();
      else warmBundleGroups();
    }
  }

  function isCanadaCart() {
    return String(root.dataset.localizationCountry || "").toUpperCase() === "CA";
  }

  function renderProtection(cart) {
    var variantId = root.dataset.protectionVariantId;
    var row = root.querySelector("[data-ap-cart-protection]");
    var price = root.querySelector("[data-ap-cart-protection-price]");
    var without = root.querySelector("[data-ap-cart-checkout-without]");
    var checkoutRow = root.querySelector(".ap-cart__checkout-row");
    var checkoutLabel = root.querySelector("[data-ap-cart-checkout-label]");
    var importDuty = root.querySelector("[data-ap-cart-import-duty]");
    if (!row) return;
    var itemCount = eligibleItems(cart).length;
    var canadaCart = isCanadaCart();
    var enabled = !canadaCart && Boolean(variantId) && itemCount > 0;
    row.hidden = !enabled;
    if (checkoutRow) checkoutRow.hidden = canadaCart ? itemCount <= 0 : !enabled;
    if (without) without.hidden = !enabled;
    if (checkoutLabel) checkoutLabel.textContent = canadaCart ? text("checkout", "Checkout") : text("checkout_plus", "Checkout+");
    if (importDuty) importDuty.hidden = !(canadaCart && itemCount > 0);
    if (price) price.textContent = root.dataset.protectionPrice ? "+" + money(root.dataset.protectionPrice) : "";
  }

  function priorityPlusItem(cart) {
    var variantId = root.dataset.priorityPlusVariantId;
    if (!variantId || !cart) return null;
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    }) || null;
  }

  function priorityPlusSelected(cart) {
    return !isCanadaCart() && Boolean(root.dataset.priorityPlusVariantId) && eligibleItems(cart).length > 0 && state.priorityPlusEnabled;
  }

  function renderPriorityPlus(cart) {
    var row = root.querySelector("[data-ap-cart-priority-plus]");
    var toggle = root.querySelector("[data-ap-cart-priority-plus-toggle]");
    var price = root.querySelector("[data-ap-cart-priority-plus-price]");
    if (!row || !toggle) return;
    var enabled = !isCanadaCart() && Boolean(root.dataset.priorityPlusVariantId) && eligibleItems(cart).length > 0;
    row.hidden = !enabled;
    toggle.checked = enabled && state.priorityPlusEnabled;
    row.classList.toggle("is-selected", toggle.checked);
    if (price) {
      var priceOff = price.querySelector(".ap-cart__priority-plus-price-off");
      var priceOn = price.querySelector(".ap-cart__priority-plus-price-on");
      if (priceOff) priceOff.textContent = root.dataset.priorityPlusPrice ? money(root.dataset.priorityPlusPrice) : "";
      if (priceOn) priceOn.textContent = root.dataset.priorityPlusPrice ? "+" + money(root.dataset.priorityPlusPrice) : "";
    }
  }

  function protectionPrice() {
    return Number(root.dataset.protectionPrice || 0);
  }

  function protectionItem(cart) {
    var variantId = root.dataset.protectionVariantId;
    if (!variantId || !cart) return null;
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    }) || null;
  }

  function checkoutUrl() {
    return localePath("/checkout");
  }

  function setCheckoutLoading(button, loading) {
    if (!button) return;
    var loadingLabel = button.querySelector("[data-ap-cart-checkout-loading]");
    button.disabled = loading;
    button.classList.toggle("is-busy", loading);
    button.setAttribute("aria-busy", loading ? "true" : "false");
    if (loadingLabel) loadingLabel.hidden = !loading;
  }

  function renderTotals(cart) {
    var subtotal = root.querySelector("[data-ap-cart-subtotal]");
    var checkoutTotal = root.querySelector("[data-ap-cart-checkout-total]");
    var checkoutCompare = root.querySelector("[data-ap-cart-checkout-compare]");
    var estimatedSavings = estimatedBundleSavings(cart);
    var displayedSubtotal = Math.max(0, eligibleCartTotal(cart) - estimatedSavings);
    if (subtotal) subtotal.textContent = money(displayedSubtotal);
    if (checkoutTotal) {
      var protection = protectionItem(cart);
      var priorityPlus = priorityPlusItem(cart);
      var priorityPlusAddOn = priorityPlusSelected(cart)
        ? Number(priorityPlus && (priorityPlus.final_line_price != null ? priorityPlus.final_line_price : priorityPlus.line_price) || root.dataset.priorityPlusPrice || 0)
        : 0;
      var protectionAddOn = !isCanadaCart() && root.dataset.protectionVariantId && eligibleItems(cart).length > 0
        ? Number(protection && (protection.final_line_price != null ? protection.final_line_price : protection.line_price) || protectionPrice())
        : 0;
      var total = displayedSubtotal + priorityPlusAddOn + protectionAddOn;
      var compareTotal = eligibleCartOriginalTotal(cart) + priorityPlusAddOn + protectionAddOn;
      checkoutTotal.textContent = money(total);
      if (checkoutCompare) {
        checkoutCompare.hidden = !(compareTotal > total);
        checkoutCompare.textContent = compareTotal > total ? money(compareTotal) : "";
      }
    }
  }

  function cleanupOrphanProtection(cart) {
    var protection = protectionItem(cart);
    if (!protection || eligibleItems(cart).length > 0) {
      state.protectionCleanupKey = null;
      return;
    }
    if (state.protectionCleanupKey === protection.key) return;
    state.protectionCleanupKey = protection.key;
    changeLine(protection.key, 0).catch(function () {
      state.protectionCleanupKey = null;
    });
  }

  function cleanupDeselectedPriorityPlus(cart) {
    var item = priorityPlusItem(cart);
    if (!item || state.priorityPlusEnabled) {
      state.priorityPlusCleanupKey = null;
      return;
    }
    if (state.priorityPlusCleanupKey === item.key) return;
    state.priorityPlusCleanupKey = item.key;
    changeLine(item.key, 0).catch(function () {
      state.priorityPlusCleanupKey = null;
    });
  }

  function estimatedBundleSavings(cart) {
    if (!state.bundleGroupsLoaded) return 0;
    var counts = bundleGroupCounts(cart);
    return eligibleItems(cart).reduce(function (sum, item) {
      return sum + Math.max(0, estimatedBundleDiscountAmount(item, counts) - actualLineDiscountAmount(item));
    }, 0);
  }

  function bridgeLoyaltyWidget() {
    if (!root.classList.contains("is-enabled")) return;
    var host = root.querySelector("[data-ap-cart-loyalty]");
    if (!host) return;
    ensureLoyaltyAccordion(host);
    holdLegacyLoyaltyBridge();
    var widget = findLoyaltyWidget();
    if (!widget) return;
    var panel = host.querySelector("[data-ap-cart-loyalty-panel]") || host;
    if (!panel.contains(widget)) panel.appendChild(widget);
    holdLegacyLoyaltyBridge();
    if (state.cart) widget.dataset.cartPrice = String(Number(state.cart.total_price || 0));
    widget.style.setProperty("display", "flex", "important");
    widget.style.setProperty("width", "100%", "important");
    widget.style.setProperty("margin", "0", "important");
    widget.style.setProperty("box-sizing", "border-box", "important");
    host.hidden = false;
    syncLoyaltyAccordion(host);
  }

  function ensureLoyaltyAccordion(host) {
    if (host.querySelector("[data-ap-cart-loyalty-toggle]")) return;
    var existing = Array.prototype.slice.call(host.childNodes);
    var toggle = document.createElement("button");
    toggle.className = "ap-cart__loyalty-toggle";
    toggle.type = "button";
    toggle.setAttribute("data-ap-cart-loyalty-toggle", "true");
    toggle.setAttribute("aria-expanded", "false");
    toggle.innerHTML = [
      '<span>' + escapeHtml(text("rewards", "Rewards")) + '</span>',
      '<svg class="ap-cart__loyalty-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>'
    ].join("");
    var panel = document.createElement("div");
    panel.className = "ap-cart__loyalty-panel";
    panel.setAttribute("data-ap-cart-loyalty-panel", "true");
    panel.hidden = true;
    existing.forEach(function (node) {
      panel.appendChild(node);
    });
    host.textContent = "";
    host.setAttribute("data-ap-loyalty-expanded", "false");
    host.appendChild(toggle);
    host.appendChild(panel);
  }

  function syncLoyaltyAccordion(host) {
    var expanded = host.getAttribute("data-ap-loyalty-expanded") === "true";
    var toggle = host.querySelector("[data-ap-cart-loyalty-toggle]");
    var panel = host.querySelector("[data-ap-cart-loyalty-panel]");
    if (toggle) toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (panel) panel.hidden = !expanded;
  }

  function toggleLoyaltyAccordion() {
    var host = root.querySelector("[data-ap-cart-loyalty]");
    if (!host) return;
    var expanded = host.getAttribute("data-ap-loyalty-expanded") === "true";
    host.setAttribute("data-ap-loyalty-expanded", expanded ? "false" : "true");
    syncLoyaltyAccordion(host);
  }

  function holdLegacyLoyaltyBridge() {
    var upnova = document.querySelector("upnova-widget");
    var shadowRoot = upnova && upnova.shadowRoot;
    var legacyHost = shadowRoot && shadowRoot.querySelector("[data-essential-loyalty-upez-host]");
    if (!legacyHost) return;
    if (!legacyHost.querySelector("[data-ap-cart-loyalty-sentinel]")) {
      var sentinel = document.createElement("span");
      sentinel.setAttribute("data-ap-cart-loyalty-sentinel", "true");
      sentinel.hidden = true;
      sentinel.textContent = "points";
      legacyHost.appendChild(sentinel);
    }
  }

  function findLoyaltyWidget() {
    var widget = document.querySelector(".honeypop-cp");
    if (widget) return widget;

    var stage = document.getElementById("essential-loyalty-cart-stage");
    if (stage) {
      widget = Array.prototype.find.call(stage.children, function (el) {
        return el.classList && el.classList.contains("honeypop-cp");
      });
      if (widget) return widget;
    }

    var upnova = document.querySelector("upnova-widget");
    var shadowRoot = upnova && upnova.shadowRoot;
    return shadowRoot ? shadowRoot.querySelector(".honeypop-cp") : null;
  }

  function startLoyaltyBridgeLoop() {
    var attempts = 0;
    window.clearInterval(state.loyaltyTimer);
    bridgeLoyaltyWidget();
    state.loyaltyTimer = window.setInterval(function () {
      attempts += 1;
      bridgeLoyaltyWidget();
      if (!root.classList.contains("is-open") || attempts > 20) {
        window.clearInterval(state.loyaltyTimer);
      }
    }, 250);
  }

  function renderCount(cart) {
    var count = root.querySelector("[data-ap-cart-count]");
    var visibleCount = eligibleItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    if (count) count.textContent = String(visibleCount);
    document.querySelectorAll(".cart-count-bubble span[aria-hidden='true']").forEach(function (el) {
      el.textContent = String(visibleCount);
    });
  }

  function render(cart) {
    renderCount(cart);
    renderShipping(cart);
    renderBundleProgress(cart);
    renderSizeUpgrade(cart);
    renderItems(cart);
    renderCompatibilityWarning(cart);
    renderRoomMistUpsell(cart);
    hydrateBundleSuggestionVisibility(cart);
    renderPriorityPlus(cart);
    renderProtection(cart);
    renderTotals(cart);
    cleanupOrphanProtection(cart);
    cleanupDeselectedPriorityPlus(cart);
    bridgeLoyaltyWidget();
    if (eligibleItems(cart).length && (!state.bundleGroupsLoaded || !state.cartGroupsLoaded)) {
      primeCartUpsells(cart);
    } else {
      scheduleRecommendations(cart);
    }
  }

  function scheduleRecommendations(cart) {
    window.clearTimeout(state.recsTimer);
    state.recsTimer = window.setTimeout(function () {
      renderRecommendations(cart);
    }, root.classList.contains("is-open") ? 120 : 320);
  }

  function renderRoomMistUpsell(cart) {
    var section = root.querySelector("[data-ap-cart-room-mist]");
    var track = root.querySelector("[data-ap-cart-room-mist-track]");
    if (!section || !track) return;
    var items = eligibleItems(cart);
    if (!items.length || cartHasProduct(cart, state.roomMistUpsellProduct && state.roomMistUpsellProduct.id)) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (state.roomMistUpsellUnavailable) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (!state.roomMistUpsellProduct) {
      loadRoomMistUpsell().then(function () {
        if (state.cart) renderRoomMistUpsell(state.cart);
      });
      section.hidden = true;
      return;
    }
    if (state.roomMistUpsellProduct.available === false) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (cartHasProduct(cart, state.roomMistUpsellProduct.id)) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    track.innerHTML = renderRoomMistUpsellCard(state.roomMistUpsellProduct);
    section.hidden = false;
  }

  function renderRoomMistUpsellCard(product) {
    var variant = product && product.variants && product.variants[0];
    if (!product || !variant) return "";
    var productUrl = localePath(product.url || ("/products/" + product.handle));
    var image = productImage(product);
    var price = productPrice(product, variant);
    return [
      '<article class="ap-cart__room-mist-card" data-ap-cart-rec="room-mist" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
        image ? '<a class="ap-cart__room-mist-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '"><img src="' + escapeHtml(imageUrl(image, 180)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>' : "",
        '<div class="ap-cart__room-mist-main">',
          '<a class="ap-cart__room-mist-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(premiumTitle(product.title).replace(/\s*Spray$/i, "")) + '</a>',
          '<p><strong>' + (price ? escapeHtml(price) : "") + '</strong> · ' + escapeHtml(text("instant_refresh", "instant refresh for rooms and entryways")) + '</p>',
        '</div>',
        '<button type="button" class="ap-cart__room-mist-add" data-ap-cart-add-rec="room-mist" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">+</button>',
      '</article>'
    ].join("");
  }

  function loadRoomMistUpsell() {
    if (state.roomMistUpsellProduct || state.roomMistUpsellUnavailable) return Promise.resolve(state.roomMistUpsellProduct);
    if (state.roomMistUpsellLoading) return state.roomMistUpsellLoading;
    state.roomMistUpsellLoading = fetch(localePath("/products/" + encodeURIComponent(ROOM_MIST_UPSELL_HANDLE) + ".js"), {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (product) {
      if (!product || product.available === false || !product.variants || !product.variants.length) {
        state.roomMistUpsellUnavailable = true;
        return null;
      }
      state.roomMistUpsellProduct = product;
      return product;
    }).catch(function () {
      state.roomMistUpsellUnavailable = true;
      return null;
    }).finally(function () {
      state.roomMistUpsellLoading = null;
    });
    return state.roomMistUpsellLoading;
  }

  function cartHasProduct(cart, productId) {
    if (!productId) return false;
    return eligibleItems(cart || { items: [] }).some(function (item) {
      return String(item.product_id) === String(productId);
    });
  }

  function renderRecommendations(cart) {
    var hasGroupRecommendations = renderGroupRecommendations();
    var hasBundleSuggestions = renderBundleSuggestions(cart);
    var hasInlineRecommendations = hasGroupRecommendations || hasBundleSuggestions;
    if (hasInlineRecommendations) {
      var fallbackSection = root.querySelector("[data-ap-cart-recs]");
      var fallbackTrack = root.querySelector("[data-ap-cart-recs-track]");
      if (fallbackSection) fallbackSection.hidden = true;
      if (fallbackTrack) fallbackTrack.innerHTML = "";
      return;
    }
    var first = recommendationSourceItem(cart);
    var section = root.querySelector("[data-ap-cart-recs]");
    var track = root.querySelector("[data-ap-cart-recs-track]");
    if (!section || !track) return;
    if (!first || !first.product_id) {
      section.hidden = true;
      track.innerHTML = "";
      return;
    }
    if (state.recommendationsFor === first.product_id) return;
    state.recommendationsFor = first.product_id;
    section.hidden = true;
    track.innerHTML = "";
    if (state.recommendationsAbort) state.recommendationsAbort.abort();
    state.recommendationsAbort = new AbortController();
    fetch(localePath("/recommendations/products.json") + "?product_id=" + encodeURIComponent(first.product_id) + "&limit=6&intent=complementary", {
      credentials: "same-origin",
      signal: state.recommendationsAbort.signal,
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (payload) {
      var products = payload && payload.products ? payload.products : [];
      return filterRecommendationProducts(products, first.product_id);
    }).then(function (products) {
      products = products || [];
      if (!products.length) return;
      return Promise.all(products.map(enrichProduct)).then(function (enriched) {
        var cards = enriched.map(function (product, index) {
          return renderRecommendationCard(product, index);
        });
        track.innerHTML = cards.join("");
        section.hidden = false;
      });
    }).catch(function () {});
  }

  function renderBundleSuggestions(cart) {
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-bundle-suggestions]"));
    if (!sections.length) return false;
    var cartProductIds = cartProductIdSet(cart);
    sections.forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-bundle-suggestions");
      var handle = section.getAttribute("data-ap-cart-bundle-handle");
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (!groupKey || !handle || !track) return;
      hideCartSuggestionCards(track, cartProductIds);
      var cacheKey = groupKey + ":" + handle;
      if (state.bundleSuggestions[groupKey] === cacheKey && track.children.length) {
        if (hasVisibleSuggestionCards(track)) {
          section.hidden = false;
          return;
        }
      }
      state.bundleSuggestions[groupKey] = cacheKey;
      if (!track.children.length) section.hidden = true;
      if (state.bundleSuggestionAborts[groupKey]) state.bundleSuggestionAborts[groupKey].abort();
      state.bundleSuggestionAborts[groupKey] = new AbortController();
      fetch(localePath("/collections/" + encodeURIComponent(handle) + "/products.json") + "?limit=12", {
        credentials: "same-origin",
        signal: state.bundleSuggestionAborts[groupKey].signal,
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        return filterCollectionSuggestionProducts(products, cartProductIds);
      }).then(function (products) {
        products = products || [];
        if (!products.length) return;
        track.innerHTML = products.slice(0, 6).map(function (product, index) {
          return renderRecommendationCard(product, index);
        }).join("");
        state.bundleSuggestionHtml[groupKey] = track.innerHTML;
        hideCartSuggestionCards(track, cartProductIds);
        section.hidden = false;
      }).catch(function () {});
    });
    return true;
  }

  function primeCartUpsells(cart) {
    if (!cart || !eligibleItems(cart).length) return;
    var key = eligibleItems(cart).map(function (item) {
      return [item.product_id || "", item.variant_id || "", item.quantity || 0].join(":");
    }).join("|");
    if (!key || state.recommendationsPrimedFor === key) return;
    state.recommendationsPrimedFor = key;
    loadCartGrouping().then(function () {
      if (state.cart) scheduleRecommendations(state.cart);
    }).catch(function () {});
  }

  function hydrateBundleSuggestionVisibility(cart) {
    var cartProductIds = cartProductIdSet(cart);
    Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-bundle-suggestions]")).forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-bundle-suggestions");
      var track = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(groupKey) + '"]');
      if (!track || !track.children.length) return;
      hideCartSuggestionCards(track, cartProductIds);
      section.hidden = !hasVisibleSuggestionCards(track);
    });
  }

  function hideCartSuggestionCards(track, cartProductIds) {
    if (!track) return;
    Array.prototype.slice.call(track.querySelectorAll("[data-ap-cart-rec-product]")).forEach(function (card) {
      var productId = card.getAttribute("data-ap-cart-rec-product");
      card.hidden = !!cartProductIds[String(productId)];
    });
  }

  function hasVisibleSuggestionCards(track) {
    if (!track) return false;
    return Array.prototype.slice.call(track.querySelectorAll("[data-ap-cart-rec-product]")).some(function (card) {
      return !card.hidden;
    });
  }

  function cartProductIdSet(cart) {
    var ids = {};
    eligibleItems(cart || { items: [] }).forEach(function (item) {
      if (item && item.product_id) ids[String(item.product_id)] = true;
    });
    return ids;
  }

  function filterCollectionSuggestionProducts(products, cartProductIds) {
    return (products || []).filter(function (product) {
      return product
        && product.id
        && !cartProductIds[String(product.id)]
        && product.available !== false
        && product.variants
        && product.variants[0];
    });
  }

  function renderGroupRecommendations() {
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-ap-cart-group-recs]"));
    if (!sections.length) return false;
    sections.forEach(function (section) {
      var groupKey = section.getAttribute("data-ap-cart-group-recs");
      var sourceProductId = section.getAttribute("data-ap-cart-group-recs-source");
      var track = root.querySelector('[data-ap-cart-group-recs-track="' + cssEscape(groupKey) + '"]');
      if (!groupKey || !sourceProductId || !track) return;
      var cacheKey = groupKey + ":" + sourceProductId;
      if (state.groupRecommendations[groupKey] === cacheKey && track.children.length) return;
      state.groupRecommendations[groupKey] = cacheKey;
      section.hidden = true;
      track.innerHTML = "";
      if (state.groupRecommendationAborts[groupKey]) state.groupRecommendationAborts[groupKey].abort();
      state.groupRecommendationAborts[groupKey] = new AbortController();
      fetch(localePath("/recommendations/products.json") + "?product_id=" + encodeURIComponent(sourceProductId) + "&limit=6&intent=complementary", {
        credentials: "same-origin",
        signal: state.groupRecommendationAborts[groupKey].signal,
        headers: { "Accept": "application/json" }
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).then(function (payload) {
        var products = payload && payload.products ? payload.products : [];
        if (groupKey === "waterless-diffusers") {
          products = products.filter(function (product) {
            return product && product.handle !== WATERLESS_CLEANER_UPSELL_HANDLE;
          });
        }
        return filterRecommendationProducts(products, sourceProductId);
      }).then(function (products) {
        products = products || [];
        if (!products.length) return;
        return Promise.all(products.map(enrichProduct)).then(function (enriched) {
          track.innerHTML = enriched.map(function (product, index) {
            return renderRecommendationCard(product, index);
          }).join("");
          section.hidden = false;
        });
      }).catch(function () {});
    });
    return true;
  }

  function filterRecommendationProducts(products, sourceProductId) {
    return (products || []).filter(function (product) {
      return product
        && String(product.id) !== String(sourceProductId)
        && product.available !== false
        && product.variants
        && product.variants[0];
    }).slice(0, 6);
  }

  function recommendationSourceItem(cart) {
    var items = eligibleItems(cart);
    if (!items.length) return null;
    return items[0];
  }

  function productJsonUrl(product) {
    if (product && product.handle) return localePath("/products/" + encodeURIComponent(product.handle) + ".js");
    if (product && product.url) return localePath(product.url.split("?")[0].replace(/\/$/, "") + ".js");
    return "";
  }

  function enrichProduct(product) {
    var url = productJsonUrl(product);
    if (!url) return Promise.resolve(product);
    return fetch(url, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (res) {
      return res.ok ? res.json() : product;
    }).then(function (fullProduct) {
      return Object.assign({}, product, fullProduct || {});
    }).catch(function () {
      return product;
    });
  }

  function variantOptions(product, recId) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant && variant.available !== false;
    });
    if (!variants.length) return "";
    return [
      '<label class="ap-cart__rec-control">',
        '<span class="visually-hidden">' + escapeHtml(text("variant", "Variant")) + '</span>',
        '<select data-ap-cart-rec-variant="' + escapeHtml(recId) + '">',
          variants.map(function (variant) {
            return '<option value="' + escapeHtml(variant.id) + '" data-price="' + escapeHtml(normalizePrice(variant.price)) + '">' + escapeHtml(variant.title || text("default_variant", "Default")) + '</option>';
          }).join(""),
        '</select>',
      '</label>'
    ].join("");
  }

  function premiumTitle(title) {
    return String(title || "")
      .replace(/\s*[|-]\s*Premium Long-Lasting.*$/i, "")
      .replace(/\s*Premium Long-Lasting.*$/i, "")
      .replace(/\s*Perfume Inspired.*$/i, "")
      .replace(/\s*Inspired By.*$/i, "")
      .replace(/\s*For Humidifying Diffusers.*$/i, "")
      .replace(/\s*Waterless Fragrance Oil.*$/i, "")
      .replace(/\s*Fragrance Oil.*$/i, "")
      .replace(/\s*[–—-]\s*$/g, "")
      .trim();
  }

  function discountBadge(price, compare) {
    price = normalizePrice(price);
    compare = normalizePrice(compare);
    if (!price || !compare || compare <= price) return "";
    return '<span class="ap-cart__rec-badge">-' + Math.round(((compare - price) / compare) * 100) + '%</span>';
  }

  function renderRecommendationCard(product, index) {
        var variant = product.variants[0];
        var image = productImage(product);
        var price = productPrice(product, variant);
        var recId = "rec-" + index + "-" + String(product.id || product.handle || variant.id).replace(/[^a-zA-Z0-9_-]/g, "");
        var productUrl = localePath(product.url || ("/products/" + product.handle));
        var compare = normalizePrice((variant && variant.compare_at_price) || product.compare_at_price);
        var comparePrice = compare && compare > normalizePrice(variant.price)
          ? '<span class="ap-cart__rec-compare">' + money(compare) + '</span>'
          : "";
        return [
          '<article class="ap-cart__rec" data-ap-cart-rec="' + escapeHtml(recId) + '" data-ap-cart-rec-product="' + escapeHtml(product.id) + '">',
            '<a class="ap-cart__rec-media" href="' + escapeHtml(productUrl) + '" aria-label="' + escapeHtml(formatText("view_product", "View __PRODUCT__", { product: product.title })) + '">',
              image ? '<img src="' + escapeHtml(imageUrl(image, 320)) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : "",
            '</a>',
            '<div class="ap-cart__rec-main">',
              '<a class="ap-cart__rec-title" href="' + escapeHtml(productUrl) + '">' + escapeHtml(premiumTitle(product.title)) + '</a>',
              '<div class="ap-cart__rec-rating" aria-label="' + escapeHtml(text("customer_rating", "Customer rating")) + '"><span aria-hidden="true">★★★★★</span></div>',
              variantOptions(product, recId),
            '</div>',
            '<div class="ap-cart__rec-side">',
              '<p class="ap-cart__rec-price" data-ap-cart-rec-price>' + (price ? escapeHtml(price) : '&nbsp;') + comparePrice + '</p>',
              '<button type="button" class="ap-cart__rec-add" data-ap-cart-add-rec="' + escapeHtml(recId) + '" data-ap-cart-add-variant="' + escapeHtml(variant.id) + '" aria-label="' + escapeHtml(formatText("add_product_to_cart", "Add __PRODUCT__ to cart", { product: product.title })) + '">',
                '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.5 7h13l-1.4 8.2a2 2 0 0 1-2 1.7H9.3a2 2 0 0 1-2-1.7L6.1 4.8H3.8"/><circle cx="9.7" cy="20" r="1.1"/><circle cx="16.7" cy="20" r="1.1"/></svg>',
              '</button>',
            '</div>',
          '</article>'
        ].join("");
  }

  function productImage(product) {
    var image = product && (product.featured_image || product.image || (product.images && product.images[0]));
    if (image && image.src) return image.src;
    return image || "";
  }

  function checkout(withProtection) {
    var cart = state.cart || { items: [] };
    if (!eligibleItems(cart).length) {
      showError(text("empty_checkout_error", "Add an item to your cart before checkout."));
      return Promise.resolve();
    }
    rememberCheckoutReturnPath();
    var updates = {};
    if (root.dataset.priorityPlusVariantId) {
      updates[root.dataset.priorityPlusVariantId] = priorityPlusSelected(cart) ? 1 : 0;
    }
    if (root.dataset.protectionVariantId) {
      updates[root.dataset.protectionVariantId] = withProtection ? 1 : 0;
    }
    if (!Object.keys(updates).length) {
      window.location.href = checkoutUrl();
      return Promise.resolve();
    }
    var startedAt = Date.now();
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timeoutId = controller ? window.setTimeout(function () {
      controller.abort();
    }, 2000) : null;
    return api(localePath("/cart/update.js") + "?hide_upez_cart=true", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
      signal: controller ? controller.signal : undefined
    }).catch(function (error) {
      trackCartEvent("checkout_update_failed", {
        checkout_plus: withProtection,
        priority_plus: priorityPlusSelected(cart),
        duration_ms: Date.now() - startedAt,
        reason: error && error.name === "AbortError" ? "timeout" : "request_failed"
      });
    }).finally(function () {
      if (timeoutId) window.clearTimeout(timeoutId);
      window.location.href = checkoutUrl();
    });
  }

  function bindEvents() {
    document.addEventListener("submit", function (event) {
      if (!root.classList.contains("is-enabled")) return;
      var form = event.target && event.target.closest && event.target.closest("form[action*='/cart/add']");
      if (!form || form.closest("[data-ap-cart]")) return;
      event.preventDefault();
      event.stopPropagation();
      submitProductAddForm(form);
    }, true);

    root.addEventListener("click", function (event) {
      var close = event.target.closest("[data-ap-cart-close]");
      if (close) {
        event.preventDefault();
        closeCart();
        return;
      }
      var importDutyInfo = event.target.closest("[data-ap-cart-import-duty] .ap-cart__info");
      if (importDutyInfo) {
        event.preventDefault();
        importDutyInfo.setAttribute("aria-expanded", importDutyInfo.getAttribute("aria-expanded") === "true" ? "false" : "true");
        return;
      }
      var sizeUpgradeReview = event.target.closest("[data-ap-cart-size-upgrade-review]");
      if (sizeUpgradeReview) {
        event.preventDefault();
        state.sizeUpgradeExpanded = !state.sizeUpgradeExpanded;
        var sizeUpgradeMount = root.querySelector("[data-ap-cart-size-upgrade]");
        if (state.cart) renderSizeUpgrade(state.cart);
        trackCartEvent("size_upgrade_review_toggled", {
          expanded: state.sizeUpgradeExpanded,
          eligible_lines: sizeUpgradeMount && sizeUpgradeMount.__apSizeUpgradePlan ? sizeUpgradeMount.__apSizeUpgradePlan.lines.length : 0,
          surface: "upgrade_all"
        });
        return;
      }
      var sizeUpgradeAll = event.target.closest("[data-ap-cart-size-upgrade-all]");
      if (sizeUpgradeAll) {
        event.preventDefault();
        var upgradeMount = root.querySelector("[data-ap-cart-size-upgrade]");
        executeSizeUpgrade(upgradeMount && upgradeMount.__apSizeUpgradePlan);
        return;
      }
      if (event.target.closest("[data-ap-cart-size-upgrade-undo]")) {
        event.preventDefault();
        undoSizeUpgrade();
        return;
      }
      var qty = event.target.closest("[data-ap-cart-qty]");
      if (qty) {
        event.preventDefault();
        var lineKey = qty.getAttribute("data-ap-cart-qty");
        var nextQty = Number(qty.getAttribute("data-qty"));
        var currentLine = cartLineByKey(lineKey);
        var previousQty = currentLine ? Number(currentLine.quantity || 0) : null;
        setLineBusy(lineKey, true);
        changeLine(lineKey, nextQty).then(function () {
          trackCartEvent(nextQty <= 0 ? "cart_item_removed" : "cart_quantity_changed", {
            line_key: lineKey,
            quantity: nextQty,
            previous_quantity: previousQty,
            product_id: currentLine && currentLine.product_id ? currentLine.product_id : "",
            variant_id: currentLine && currentLine.variant_id ? currentLine.variant_id : "",
            product_title: currentLine && currentLine.product_title ? currentLine.product_title : ""
          });
        }).catch(function () {
          showError(text("item_update_error", "We couldn't update this item. Please try again."));
        }).finally(function () {
          setLineBusy(lineKey, false);
        });
        return;
      }
      var add = event.target.closest("[data-ap-cart-add-variant]");
      if (add) {
        event.preventDefault();
        var originalLabel = add.textContent;
        var isIconButton = add.classList.contains("ap-cart__rec-add") || add.classList.contains("ap-cart__room-mist-add") || add.classList.contains("ap-cart__line-cleaner-add");
        var recCard = add.closest("[data-ap-cart-rec]");
        if (recCard) {
          recCard.classList.remove("is-adding", "is-added");
          void recCard.offsetWidth;
          recCard.classList.add("is-adding");
        }
        setCartMutating(true);
        add.disabled = true;
        add.classList.add("is-busy");
        if (!isIconButton) add.textContent = text("adding", "Adding");
        addVariant(add.getAttribute("data-ap-cart-add-variant"), 1).then(function () {
          var recSource = recommendationSource(recCard);
          var recPayload = Object.assign({
            variant_id: add.getAttribute("data-ap-cart-add-variant") || "",
            recommendation_id: recCard ? recCard.getAttribute("data-ap-cart-rec") || "" : "",
            product_id: recCard ? recCard.getAttribute("data-ap-cart-rec-product") || "" : ""
          }, recSource);
          trackCartEvent("recommendation_added", recPayload);
          if (recSource.source === "bundle_suggestion") {
            trackCartEvent("bundle_suggestion_added", recPayload);
          }
          if (recSource.source === "room_mist_upsell") {
            trackCartEvent("room_mist_upsell_added", recPayload);
          }
          if (recSource.source === "humidifying_cleaner_upsell") {
            trackCartEvent("humidifying_cleaner_upsell_added", recPayload);
          }
          if (recSource.source === "waterless_cleaner_upsell") {
            trackCartEvent("waterless_cleaner_upsell_added", recPayload);
          }
          if (recSource.source === "fragrance_dropper_upsell") {
            trackCartEvent("fragrance_dropper_upsell_added", recPayload);
          }
          if (!isIconButton) add.textContent = text("added", "Added");
          add.classList.add("is-added");
          if (recCard) {
            recCard.classList.remove("is-added");
            void recCard.offsetWidth;
            recCard.classList.add("is-added");
          }
        }).catch(function () {
          showError(text("add_error", "We couldn't add that product. Please try again."));
          if (!isIconButton) add.textContent = originalLabel;
        }).finally(function () {
          window.setTimeout(function () {
            add.disabled = false;
            add.classList.remove("is-busy");
            add.classList.remove("is-added");
            if (recCard) recCard.classList.remove("is-adding", "is-added");
            setCartMutating(false);
            if (!isIconButton) add.textContent = originalLabel;
          }, 700);
        });
        return;
      }
      if (event.target.closest("[data-ap-cart-loyalty-toggle]")) {
        event.preventDefault();
        toggleLoyaltyAccordion();
        var loyaltyHost = root.querySelector("[data-ap-cart-loyalty]");
        trackCartEvent("rewards_toggled", {
          expanded: loyaltyHost ? loyaltyHost.getAttribute("data-ap-loyalty-expanded") === "true" : false
        });
        return;
      }
      var bundleSuggestionsButton = event.target.closest("[data-ap-cart-bundle-suggestions-prev], [data-ap-cart-bundle-suggestions-next]");
      if (bundleSuggestionsButton) {
        event.preventDefault();
        var bundleKey = bundleSuggestionsButton.getAttribute("data-ap-cart-bundle-suggestions-prev") || bundleSuggestionsButton.getAttribute("data-ap-cart-bundle-suggestions-next");
        var bundleTrack = root.querySelector('[data-ap-cart-bundle-suggestions-track="' + cssEscape(bundleKey) + '"]');
        var bundleDirection = bundleSuggestionsButton.hasAttribute("data-ap-cart-bundle-suggestions-prev") ? -1 : 1;
        if (bundleTrack) {
          bundleTrack.scrollBy({
            left: bundleDirection * Math.max(150, Math.round(bundleTrack.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      var groupRecsButton = event.target.closest("[data-ap-cart-group-recs-prev], [data-ap-cart-group-recs-next]");
      if (groupRecsButton) {
        event.preventDefault();
        var groupKey = groupRecsButton.getAttribute("data-ap-cart-group-recs-prev") || groupRecsButton.getAttribute("data-ap-cart-group-recs-next");
        var groupTrack = root.querySelector('[data-ap-cart-group-recs-track="' + cssEscape(groupKey) + '"]');
        var groupDirection = groupRecsButton.hasAttribute("data-ap-cart-group-recs-prev") ? -1 : 1;
        if (groupTrack) {
          groupTrack.scrollBy({
            left: groupDirection * Math.max(150, Math.round(groupTrack.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      if (event.target.closest("[data-ap-cart-recs-prev], [data-ap-cart-recs-next]")) {
        event.preventDefault();
        var track = root.querySelector("[data-ap-cart-recs-track]");
        var direction = event.target.closest("[data-ap-cart-recs-prev]") ? -1 : 1;
        if (track) {
          track.scrollBy({
            left: direction * Math.max(150, Math.round(track.clientWidth * 0.82)),
            behavior: "smooth"
          });
        }
        return;
      }
      if (event.target.closest("[data-ap-cart-checkout-plus]")) {
        event.preventDefault();
        var checkoutButton = event.target.closest("[data-ap-cart-checkout-plus]");
        if (checkoutButton.classList.contains("is-busy")) return;
        var withProtection = !isCanadaCart();
        setCheckoutLoading(checkoutButton, true);
        trackCartEvent(withProtection ? "checkout_plus_clicked" : "checkout_clicked", { checkout_plus: withProtection });
        checkout(withProtection).catch(function () {
          setCheckoutLoading(checkoutButton, false);
          showError(text("checkout_error", "Checkout couldn't start. Please try again."));
        });
        return;
      }
      if (event.target.closest("[data-ap-cart-checkout-without]")) {
        event.preventDefault();
        var withoutButton = event.target.closest("[data-ap-cart-checkout-without]");
        withoutButton.classList.add("is-busy");
        trackCartEvent("continue_without_checkout_plus", { checkout_plus: false });
        checkout(false).catch(function () {
          withoutButton.classList.remove("is-busy");
          window.location.href = checkoutUrl();
        });
      }
    });

    root.addEventListener("change", function (event) {
      var priorityPlusToggle = event.target.closest("[data-ap-cart-priority-plus-toggle]");
      if (priorityPlusToggle) {
        writePriorityPlusPreference(priorityPlusToggle.checked);
        var priorityPlusRow = root.querySelector("[data-ap-cart-priority-plus]");
        if (priorityPlusRow) {
          priorityPlusRow.classList.toggle("is-selected", priorityPlusToggle.checked);
        }
        renderTotals(state.cart || { items: [] });
        if (!priorityPlusToggle.checked && state.cart) cleanupDeselectedPriorityPlus(state.cart);
        trackCartEvent("priority_plus_toggled", {
          enabled: priorityPlusToggle.checked,
          price: Number(root.dataset.priorityPlusPrice || 0) / 100
        });
        return;
      }
      var variantSelect = event.target.closest("[data-ap-cart-rec-variant]");
      if (!variantSelect) return;
      var rec = variantSelect.closest("[data-ap-cart-rec]");
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var button = rec && rec.querySelector("[data-ap-cart-add-variant]");
      var price = rec && rec.querySelector("[data-ap-cart-rec-price]");
      if (button) button.setAttribute("data-ap-cart-add-variant", variantSelect.value);
      if (price && selected && selected.getAttribute("data-price")) {
        price.textContent = money(selected.getAttribute("data-price"));
      }
      trackCartEvent("recommendation_variant_selected", {
        variant_id: variantSelect.value,
        recommendation_id: rec ? rec.getAttribute("data-ap-cart-rec") || "" : "",
        product_id: rec ? rec.getAttribute("data-ap-cart-rec-product") || "" : "",
        price: selected && selected.getAttribute("data-price") ? Number(selected.getAttribute("data-price")) / 100 : ""
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-open")) closeCart();
    });

    document.addEventListener("click", function (event) {
      if (!root.classList.contains("is-enabled")) return;
      var panel = root.querySelector(".ap-cart__panel");
      if (root.classList.contains("is-open") && panel && !panel.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        closeCart();
        return;
      }
      var cartLink = event.target.closest("#cart-icon-bubble, a[href='/cart'], a[href$='/cart']");
      if (!cartLink) return;
      event.preventDefault();
      event.stopPropagation();
      openCart();
    }, true);

    ["cart:added", "cart:refresh", "cart:updated", "UPEZ__ADDED_ITEM", "UPEZ__CART_REFETCHED_AFTER_ADD", "UPEZ__CART_REFETCHED_AFTER_CHANGE", "UPEZ__REMOVED_ITEM"].forEach(function (name) {
      document.addEventListener(name, function () {
        if (root.classList.contains("is-enabled")) {
          scheduleCartRefresh(140);
        }
      });
    });
  }

  function submitProductAddForm(form) {
    var submitter = document.activeElement && form.contains(document.activeElement)
      ? document.activeElement
      : form.querySelector("[type='submit']");
    var formData = new FormData(form);
    var variantId = formData.get("id") || "";
    var quantity = Number(formData.get("quantity") || 1);
    var followUpInput = form.querySelector("[data-ap-followup-addon]:checked");
    var followUpVariantId = followUpInput ? Number(followUpInput.getAttribute("data-variant-id") || 0) : 0;
    var followUpName = followUpInput ? followUpInput.getAttribute("data-addon-name") || "Optional add-on" : "";
    var followUpFailed = false;
    if (submitter) {
      submitter.disabled = true;
      submitter.classList.add("is-busy");
    }
    api(hiddenCartUrl(localePath("/cart/add.js")), {
      method: "POST",
      body: formData
    }).then(function (result) {
      clearError();
      if (isProductPage()) {
        document.dispatchEvent(new CustomEvent("ap:pdp:purchase_success", {
          detail: { source: "product_form", payload: result }
        }));
      }
      if (!followUpVariantId) return result;
      return api(hiddenCartUrl(localePath("/cart/add.js")), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: followUpVariantId, quantity: 1, properties: { "_addon": followUpName } }] })
      }).then(function (addonResult) {
        document.dispatchEvent(new CustomEvent("ap:pdp:followup_addon_success", {
          detail: { variant_id: followUpVariantId, name: followUpName, source: "product_form" }
        }));
        trackCartEvent("pdp_followup_addon_added", {
          variant_id: followUpVariantId,
          name: followUpName,
          source: "product_form"
        });
        return result;
      }).catch(function () {
        followUpFailed = true;
        trackCartEvent("pdp_followup_addon_failed", {
          variant_id: followUpVariantId,
          name: followUpName,
          source: "product_form"
        });
        return result;
      });
    }).then(function (result) {
      return openOrRefreshAfterAdd().then(function () {
        if (followUpFailed) showError("Your product was added, but the optional add-on wasn't. You can still check out.");
        trackCartEvent("cart_product_form_added", {
          variant_id: variantId,
          quantity: quantity,
          source: "product_form"
        });
      });
    }).catch(function () {
      showError(text("add_error", "We couldn't add that product. Please try again."));
    }).finally(function () {
      if (submitter) {
        submitter.disabled = false;
        submitter.classList.remove("is-busy");
      }
    });
  }

  function patchCartMutations() {
    if (window.__apCartDrawerPatched) return;
    window.__apCartDrawerPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var args = Array.prototype.slice.call(arguments);
      if (root.classList.contains("is-enabled") && isAdd && typeof input === "string") {
        args[0] = hiddenCartUrl(input);
      }
      var result = nativeFetch.apply(this, args);
      if (root.classList.contains("is-enabled") && isAdd) {
        result.then(function (res) {
          if (res && res.ok) setTimeout(openOrRefreshAfterAdd, 180);
        }).catch(function () {});
      }
      return result;
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      var args = Array.prototype.slice.call(arguments);
      if (root.classList.contains("is-enabled") && /\/cart\/add(\.js)?(\?|$)/.test(String(url || ""))) {
        args[1] = hiddenCartUrl(url);
      }
      this.__apCartDrawerUrl = args[1];
      return nativeOpen.apply(this, args);
    };
    XMLHttpRequest.prototype.send = function () {
      if (root.classList.contains("is-enabled") && /\/cart\/add(\.js)?(\?|$)/.test(this.__apCartDrawerUrl || "")) {
        this.addEventListener("loadend", function () {
          if (this.status >= 200 && this.status < 300) setTimeout(openOrRefreshAfterAdd, 180);
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function warmBundleGroups() {
    if (state.bundleGroupsLoaded || state.bundleGroupsLoading) return;
    if (readBundleGroupCache()) return;
    var warm = function () { loadBundleGroups(); };
    if ("requestIdleCallback" in window) window.requestIdleCallback(warm, { timeout: 1800 });
    else window.setTimeout(warm, 900);
  }

  function init() {
    if (!hasFlag()) return;
    root.classList.add("is-enabled");
    document.body.classList.add("ap-cart-native-mode");
    closeNativeCartDrawer();
    window.apCartDrawer = {
      open: openCart,
      close: closeCart,
      refresh: fetchCart,
      disable: function () {
        window.localStorage.removeItem(FLAG);
        closeCart();
        root.classList.remove("is-enabled");
        document.body.classList.remove("ap-cart-native-mode");
      }
    };
    bindEvents();
    patchCartMutations();
    installScrollStyles();
    installScrollGuards();
    var initialCart = fetchCart().then(bridgeLoyaltyWidget);
    if (shouldOpenOnLoad()) {
      initialCart.then(function () {
        openCart({ skipRefresh: true });
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("ap_cart");
        cleanUrl.searchParams.delete("ap_cart_open");
        window.history.replaceState(window.history.state, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      });
    }
    warmCartGrouping();
    window.setTimeout(bridgeLoyaltyWidget, 900);
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      root.querySelectorAll("[data-ap-cart-checkout-plus], [data-ap-cart-checkout-without]").forEach(function (button) {
        if (button.hasAttribute("data-ap-cart-checkout-plus")) setCheckoutLoading(button, false);
        else {
          button.disabled = false;
          button.classList.remove("is-busy");
        }
      });
      fetchCart().then(bridgeLoyaltyWidget);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
